export const Popular=
{
    "kind": "youtube#videoListResponse",
    "etag": "oIacUPlBBkniGVWVjba3luBBXzM",
    "items": [
      {
        "kind": "youtube#video",
        "etag": "Yza4uNNURTxWKqD9v689G00lFGc",
        "id": "Bbyftsl7Owo",
        "snippet": {
          "publishedAt": "2020-12-22T20:01:49Z",
          "channelId": "UCucot-Zp428OwkyRm2I7v2Q",
          "title": "Best Friends Buy Each Other Christmas Gifts!",
          "description": "HI SISTERS! Happy Holidays! Today's video is another massive collabs with my best friends, Charli & Dixie D'Amelio, Noah Beck, Larray, and Chase Hudson! We played Secret Santa and got each other super emotional gifts to celebrate an amazing year all together. We hope you enjoy and don't forget to thumbs up and subscribe!!\n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nNOAH'S VIDEO » https://youtu.be/KLjUPvrSG_Q\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\nLARRAY'S VIDEO » https://youtu.be/R3JQPlYb6vg\n\n🎥 PREVIOUS VIDEO » \n👕 SISTER'S APPAREL » http://sisters-apparel.com\n🛎 Subscribe to my channel to join the sisterhood & hit the notification bell so you never miss an upload! » http://bit.ly/JamesCharles for new videos!\n\n💞 LET'S BE BFFS\nTEXT ME! » 310-905-8746\nINSTAGRAM » http://instagram.com/jamescharles\nFACEBOOK » http://facebook.com/jcharlesbeauty\nTWITTER » http://twitter.com/jamescharles\nSNAPCHAT » jamescharless\nTIKTOK » jamescharles\n\n💌 Business Inquiries » business@spinandco.com\n\n💸 COUPON CODES 💸\nUSE CODE JAMES FOR MONEY OFF YOUR ORDER!\nMORPHE » http://morphebrushes.com\nLILLY LASHES » https://lillylashes.com/\nLAURAS BOUTIQUE » http://lauras-boutique.com\n\n🔥 MY AMAZING TEAM\nDIRECTOR OF CONTENT: Louis Gargiula\nhttp://instagram.com/louisgargiula\nEDITOR: Ryan Allen\nhttp://www.youtube.com/user/helloxryan \nGRAPHICS: Michael Rusakov\nhttp://instagram.com/michael.ny\nOUTRO SONG: Earcandy\nhttps://earcandy.lnk.to/christmas/",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/Bbyftsl7Owo/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/Bbyftsl7Owo/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/Bbyftsl7Owo/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/Bbyftsl7Owo/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/Bbyftsl7Owo/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "James Charles",
          "tags": [
            "james",
            "james charles",
            "makeup artist",
            "mua",
            "covergirl",
            "coverboy",
            "cute",
            "easy makeup",
            "how-to",
            "reviews",
            "tutorials",
            "funny videos",
            "beauty tips",
            "hacks",
            "beauty",
            "sister",
            "sisters apparel",
            "morphe",
            "james charles x morphe",
            "lips",
            "prom makeup",
            "tik tok makeup",
            "tik tok hacks",
            "tik tok beauty hacks",
            "christmas",
            "christmas gifts",
            "secret santa",
            "best friends",
            "charli d'amelio",
            "dixie d'amelio",
            "chase hudson",
            "lilhuddy",
            "larri",
            "larrayxo",
            "noah beck",
            "squad",
            "best friends halloween",
            "best friends christmas",
            "holiday special"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en",
          "localized": {
            "title": "Best Friends Buy Each Other Christmas Gifts!",
            "description": "HI SISTERS! Happy Holidays! Today's video is another massive collabs with my best friends, Charli & Dixie D'Amelio, Noah Beck, Larray, and Chase Hudson! We played Secret Santa and got each other super emotional gifts to celebrate an amazing year all together. We hope you enjoy and don't forget to thumbs up and subscribe!!\n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nNOAH'S VIDEO » https://youtu.be/KLjUPvrSG_Q\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\nLARRAY'S VIDEO » https://youtu.be/R3JQPlYb6vg\n\n🎥 PREVIOUS VIDEO » \n👕 SISTER'S APPAREL » http://sisters-apparel.com\n🛎 Subscribe to my channel to join the sisterhood & hit the notification bell so you never miss an upload! » http://bit.ly/JamesCharles for new videos!\n\n💞 LET'S BE BFFS\nTEXT ME! » 310-905-8746\nINSTAGRAM » http://instagram.com/jamescharles\nFACEBOOK » http://facebook.com/jcharlesbeauty\nTWITTER » http://twitter.com/jamescharles\nSNAPCHAT » jamescharless\nTIKTOK » jamescharles\n\n💌 Business Inquiries » business@spinandco.com\n\n💸 COUPON CODES 💸\nUSE CODE JAMES FOR MONEY OFF YOUR ORDER!\nMORPHE » http://morphebrushes.com\nLILLY LASHES » https://lillylashes.com/\nLAURAS BOUTIQUE » http://lauras-boutique.com\n\n🔥 MY AMAZING TEAM\nDIRECTOR OF CONTENT: Louis Gargiula\nhttp://instagram.com/louisgargiula\nEDITOR: Ryan Allen\nhttp://www.youtube.com/user/helloxryan \nGRAPHICS: Michael Rusakov\nhttp://instagram.com/michael.ny\nOUTRO SONG: Earcandy\nhttps://earcandy.lnk.to/christmas/"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT17M",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "6313351",
          "likeCount": "468811",
          "dislikeCount": "7193",
          "favoriteCount": "0",
          "commentCount": "30588"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "vL8---q_KCELkk2OKmJdlRmOVEw",
        "id": "I9RC_DANDAM",
        "snippet": {
          "publishedAt": "2020-12-22T20:00:04Z",
          "channelId": "UCLOEGprmycLLbyzBj2jozLg",
          "title": "Best Friends Play White Elephant | Dixie D'Amelio",
          "description": "Heyy! For Christmas, we all got together for a fun weekend of Christmas content. I hope you enjoy watching us all play white elephant! We had such a great weekend together, I can't wait to do it again!! Don't forget to watch all my friend's videos from our Christmas collabs! Thanks, @James Charles @charli d'amelio @Noah Beck @Chase Hudson @LARRAY \n\nJames' video: https://youtu.be/Bbyftsl7Owo\nCharli's video: https://youtu.be/20WNckAJbXU\nLarray's video: https://youtu.be/R3JQPlYb6vg\nNoah's video: https://youtu.be/KLjUPvrSG_Q\nChase's video: https://youtu.be/PIiY2z1A27A\n\nConnect with me!\nTikTok: https://www.tiktok.com/@dixiedamelio\nInstagram: https://www.instagram.com/dixiedamelio\nTwitter: https://twitter.com/dixiedamelio\nWebsite: https://www.dixiedamelio.com\n\n#dixiedamelio #christmas",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/I9RC_DANDAM/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/I9RC_DANDAM/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/I9RC_DANDAM/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/I9RC_DANDAM/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/I9RC_DANDAM/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Dixie D'Amelio",
          "tags": [
            "dixie damelio",
            "dixie d'amelio",
            "dixie",
            "damelio",
            "be happy",
            "music video",
            "tik tok",
            "official music video",
            "dixie damelio be happy",
            "dixie d'amelio be happy",
            "dixie damelio music video",
            "dixie d'amelio music video",
            "charli damelio",
            "charli d'amelio",
            "tiktok",
            "charli",
            "d'amelio",
            "behind the scenes",
            "bts",
            "exclusive",
            "ᗷᕼᑌᗴᔕᒍYᗴᔕ",
            "markell washington",
            "marc d'amelio",
            "heidi d'amelio",
            "james charles",
            "chase hudson",
            "lil huddy",
            "larray",
            "noah beck",
            "christmas",
            "holidays",
            "gift",
            "gifts",
            "presents"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Best Friends Play White Elephant | Dixie D'Amelio",
            "description": "Heyy! For Christmas, we all got together for a fun weekend of Christmas content. I hope you enjoy watching us all play white elephant! We had such a great weekend together, I can't wait to do it again!! Don't forget to watch all my friend's videos from our Christmas collabs! Thanks, @James Charles @charli d'amelio @Noah Beck @Chase Hudson @LARRAY \n\nJames' video: https://youtu.be/Bbyftsl7Owo\nCharli's video: https://youtu.be/20WNckAJbXU\nLarray's video: https://youtu.be/R3JQPlYb6vg\nNoah's video: https://youtu.be/KLjUPvrSG_Q\nChase's video: https://youtu.be/PIiY2z1A27A\n\nConnect with me!\nTikTok: https://www.tiktok.com/@dixiedamelio\nInstagram: https://www.instagram.com/dixiedamelio\nTwitter: https://twitter.com/dixiedamelio\nWebsite: https://www.dixiedamelio.com\n\n#dixiedamelio #christmas"
          }
        },
        "contentDetails": {
          "duration": "PT14M6S",
          "dimension": "2d",
          "definition": "sd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "3764016",
          "likeCount": "241587",
          "dislikeCount": "3252",
          "favoriteCount": "0",
          "commentCount": "11406"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "5ZhB-yBQpIlhLDldllLT5AZgF0M",
        "id": "KLjUPvrSG_Q",
        "snippet": {
          "publishedAt": "2020-12-22T20:01:59Z",
          "channelId": "UClPsjnF7D_Ar1ZSrEsnTxJA",
          "title": "Gingerbread House Competition Ft. My Best Friends",
          "description": "What's up guys and Happy Holidays!! In today's video my best friends and I will be pairing up to compete to see who can make the best Gingerbread House. May the best pair win!!\n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nLARRAY'S VIDEO » \nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\n\n...to see more of me, follow my social medias below!!\n\nGET YOUR MERCH (ur luv'd): https://shopurluvd.com/\nInstagram: https://www.instagram.com/noahbeck/?hl=en\nTikTok: http://vm.tiktok.com/ZMJm2bnHd/\nTwitter: https://twitter.com/noahbeck?s=11\nSnapchat: noah_beck8",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/KLjUPvrSG_Q/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/KLjUPvrSG_Q/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/KLjUPvrSG_Q/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/KLjUPvrSG_Q/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/KLjUPvrSG_Q/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Noah Beck",
          "tags": [
            "dixie d’amelio",
            "charli d’amelio",
            "james charles",
            "larraye",
            "lilhuddy",
            "chase hudson",
            "noah beck",
            "dixie",
            "charli",
            "noah",
            "chase",
            "larri",
            "james",
            "christmas collab",
            "xmas",
            "gingerbread",
            "gingerbread contest",
            "collab",
            "doah"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Gingerbread House Competition Ft. My Best Friends",
            "description": "What's up guys and Happy Holidays!! In today's video my best friends and I will be pairing up to compete to see who can make the best Gingerbread House. May the best pair win!!\n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nLARRAY'S VIDEO » \nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\n\n...to see more of me, follow my social medias below!!\n\nGET YOUR MERCH (ur luv'd): https://shopurluvd.com/\nInstagram: https://www.instagram.com/noahbeck/?hl=en\nTikTok: http://vm.tiktok.com/ZMJm2bnHd/\nTwitter: https://twitter.com/noahbeck?s=11\nSnapchat: noah_beck8"
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT15M5S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2439429",
          "likeCount": "168879",
          "dislikeCount": "2422",
          "favoriteCount": "0",
          "commentCount": "7442"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "bODfby9MSVPbzsBr5dP3BAB4hOM",
        "id": "20WNckAJbXU",
        "snippet": {
          "publishedAt": "2020-12-22T20:00:00Z",
          "channelId": "UCi3OE-aN09WOcN9d2stCvPg",
          "title": "Best Friends Omegle Christmas Carols With Fans | Charli D'Amelio",
          "description": "hey everyone! we all had some much fun with our halloween videos that we wanted to do it again. we all got together recently to do the best friends weekend to make a bunch of Christmas videos that you're all going to love. thanks to  @James Charles for having us over and thanks to all of my friends  @Dixie D'Amelio @Chase Hudson @Noah Beck @LARRAY \n\njames' video: https://youtu.be/Bbyftsl7Owo\ndixie's video: https://youtu.be/I9RC_DANDAM\nlarray's video: https://youtu.be/R3JQPlYb6vg\nnoah's video: https://youtu.be/KLjUPvrSG_Q\nchase's video: https://youtu.be/PIiY2z1A27A\n\nmy socials: \nwebsite: https://www.charlidamelio.com/\ntik tok: https://www.tiktok.com/@charlidamelio\ninstagram: https://www.instagram.com/charlidamelio/\nyoutube: https://www.youtube.com/charlidamelio\nadd me on snap: https://www.snapchat.com/add/damelioc\n\n\n\n#charlidamelio #christmas",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/20WNckAJbXU/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/20WNckAJbXU/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/20WNckAJbXU/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/20WNckAJbXU/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/20WNckAJbXU/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "charli d'amelio",
          "tags": [
            "charli",
            "charlie",
            "charli d'amelio",
            "charli damelio",
            "damelio",
            "d'amelio",
            "tik tok",
            "music video",
            "official music video",
            "dixie damelio",
            "dixie d'amelio",
            "dixie",
            "tiktok",
            "exclusive",
            "marc d'amelio",
            "heidi d'amelio",
            "caifornia",
            "vlog",
            "charlie d'amelio",
            "charlie damelio",
            "music",
            "halloween",
            "james charles",
            "lil huddy",
            "chase hudson",
            "noah beck",
            "larray",
            "treats"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Best Friends Omegle Christmas Carols With Fans | Charli D'Amelio",
            "description": "hey everyone! we all had some much fun with our halloween videos that we wanted to do it again. we all got together recently to do the best friends weekend to make a bunch of Christmas videos that you're all going to love. thanks to  @James Charles for having us over and thanks to all of my friends  @Dixie D'Amelio @Chase Hudson @Noah Beck @LARRAY \n\njames' video: https://youtu.be/Bbyftsl7Owo\ndixie's video: https://youtu.be/I9RC_DANDAM\nlarray's video: https://youtu.be/R3JQPlYb6vg\nnoah's video: https://youtu.be/KLjUPvrSG_Q\nchase's video: https://youtu.be/PIiY2z1A27A\n\nmy socials: \nwebsite: https://www.charlidamelio.com/\ntik tok: https://www.tiktok.com/@charlidamelio\ninstagram: https://www.instagram.com/charlidamelio/\nyoutube: https://www.youtube.com/charlidamelio\nadd me on snap: https://www.snapchat.com/add/damelioc\n\n\n\n#charlidamelio #christmas"
          }
        },
        "contentDetails": {
          "duration": "PT13M41S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "3334163",
          "likeCount": "288776",
          "dislikeCount": "3325",
          "favoriteCount": "0",
          "commentCount": "12769"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "kvltdu_Dz-NOCAvpFltNrJXaAe4",
        "id": "R3JQPlYb6vg",
        "snippet": {
          "publishedAt": "2020-12-22T22:30:31Z",
          "channelId": "UCt_DaLB_NDqPVxezyvcfRtg",
          "title": "THE TRUTH BEHIND OUR FRIENDSHIP",
          "description": "THE TRUTH BEHIND OUR FRIENDSHIP\n\nthis is the most realest video we've ever filmed HAHAHH \n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nNOAH'S VIDEO » https://youtu.be/KLjUPvrSG_Q\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\n\ntext me 1(909) 371-5991 \n\nSnapchat: Larrayxo\n\nTwitter: larrayxo \n\nInstagram: larray \n\nbusiness: larraybizz@gmail.com\n\nplease confuse everyone and comment \"are yall straight?\"\n\n#Larray #CharliDamelio #Friendship",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/R3JQPlYb6vg/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/R3JQPlYb6vg/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/R3JQPlYb6vg/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/R3JQPlYb6vg/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/R3JQPlYb6vg/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "LARRAY",
          "tags": [
            "LARRAY",
            "THE TRUTH BEHIND OUR FRIENDSHIP",
            "larray youtube",
            "the truth",
            "friendship",
            "the truth behind our friendship larray",
            "larri",
            "larray videos",
            "charli d'amelio",
            "dixie d'amelio",
            "james charles",
            "noah beck",
            "larray friends",
            "girlies",
            "the truth behind",
            "friends",
            "larray cancelled",
            "canceled larray",
            "the tea",
            "d'amelio family",
            "charli",
            "dixie",
            "our friendship",
            "tiktok",
            "tiktok influencers",
            "tiktok room",
            "larray youtube channel",
            "tiktok influencer marketing",
            "trending",
            "trending now",
            "december 2020"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "THE TRUTH BEHIND OUR FRIENDSHIP",
            "description": "THE TRUTH BEHIND OUR FRIENDSHIP\n\nthis is the most realest video we've ever filmed HAHAHH \n\nJAMES'S VIDEO » https://youtu.be/Bbyftsl7Owo\nCHARLI'S VIDEO » https://youtu.be/20WNckAJbXU\nDIXIE'S VIDEO » https://youtu.be/I9RC_DANDAM\nNOAH'S VIDEO » https://youtu.be/KLjUPvrSG_Q\nCHASE'S VIDEO » https://youtu.be/PIiY2z1A27A\n\ntext me 1(909) 371-5991 \n\nSnapchat: Larrayxo\n\nTwitter: larrayxo \n\nInstagram: larray \n\nbusiness: larraybizz@gmail.com\n\nplease confuse everyone and comment \"are yall straight?\"\n\n#Larray #CharliDamelio #Friendship"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT9M20S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2111446",
          "likeCount": "240057",
          "dislikeCount": "1141",
          "favoriteCount": "0",
          "commentCount": "12611"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "pkcMB1OIK-h55CdsI4z6_qPXKlc",
        "id": "PIiY2z1A27A",
        "snippet": {
          "publishedAt": "2020-12-22T20:00:04Z",
          "channelId": "UC9APf0VQtg1VriRFjk9RfFQ",
          "title": "Christmas Dinner with My Best Friends ft. Charli, Dixie, Noah, James & Larray | Chase Hudson",
          "description": "THANK YOU all so much for watching the video !\nif you want to see more yt content make sure to like, subscribe, and turn on my post notifications to be the first to see my videos !\n\ncomment what you want to see next !\n\ncheck out my latest merch !! : https://www.fanjoy.co/chase\n\nsocials\n\ninstagram - https://instagram.com/lilhuddy\n\nsnap - https://snapchat.com/lilhuddy1\n\ntwitter - https://twitter.com/xlilhuddy\n\ncheck out my friends' videos !\n\njames' video - https://youtu.be/Bbyftsl7Owo\ncharli's video - https://youtu.be/20WNckAJbXU\ndixie's video - https://youtu.be/I9RC_DANDAM\nnoah's video - https://youtu.be/KLjUPvrSG_Q",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/PIiY2z1A27A/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/PIiY2z1A27A/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/PIiY2z1A27A/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/PIiY2z1A27A/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/PIiY2z1A27A/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Chase Hudson",
          "tags": [
            "Chase Hudson",
            "lilhuddy",
            "lil huddy",
            "hype house",
            "hype",
            "Charli d'amelio",
            "dixie d'amelio",
            "noah beck",
            "larray",
            "James charles",
            "sisters",
            "sisters squad",
            "tiktok"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Christmas Dinner with My Best Friends ft. Charli, Dixie, Noah, James & Larray | Chase Hudson",
            "description": "THANK YOU all so much for watching the video !\nif you want to see more yt content make sure to like, subscribe, and turn on my post notifications to be the first to see my videos !\n\ncomment what you want to see next !\n\ncheck out my latest merch !! : https://www.fanjoy.co/chase\n\nsocials\n\ninstagram - https://instagram.com/lilhuddy\n\nsnap - https://snapchat.com/lilhuddy1\n\ntwitter - https://twitter.com/xlilhuddy\n\ncheck out my friends' videos !\n\njames' video - https://youtu.be/Bbyftsl7Owo\ncharli's video - https://youtu.be/20WNckAJbXU\ndixie's video - https://youtu.be/I9RC_DANDAM\nnoah's video - https://youtu.be/KLjUPvrSG_Q"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT7M5S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1773428",
          "likeCount": "140334",
          "dislikeCount": "738",
          "favoriteCount": "0",
          "commentCount": "2928"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Vgx_UttHUHMeEXy-HknMfrNxhNI",
        "id": "sY8gUtyeAKE",
        "snippet": {
          "publishedAt": "2020-12-22T14:59:46Z",
          "channelId": "UCQJWtTnAHhEG5w4uN0udnUQ",
          "title": "Coming 2 America - Official Trailer",
          "description": "Set in the lush and royal country of Zamunda, newly-crowned King Akeem (Eddie Murphy) and his trusted confidante Semmi(Arsenio Hall) embark on an all-new hilarious adventure that has them traversing the globe from their great African nation to the borough of Queens, New York – where it all began. Available March 5th on Prime Video. Starring: Eddie Murphy, Arsenio Hall, Jermaine Fowler, Leslie Jones, Tracy Morgan, KiKi Layne, Shari Headley, with Wesley Snipes and James Earl Jones. Also starring John Amos, Teyana Taylor, Vanessa Bell Calloway, Paul Bates, Nomzamo Mbatha, Bella Murphy Screenplay by: Kenya Barris and Barry W. Blaustein & David Sheffield Story by: Barry W. Blaustein & David Sheffield and Justin Kanew Directed by: Craig Brewer Based on characters created by: Eddie Murphy Produced by: Kevin Misher and Eddie Murphy Costumes by: Ruth E. Carter.\n\n» SUBSCRIBE: http://bit.ly/PrimeVideoSubscribe\r\n \r\nAbout Prime Video:\r\nWant to watch it now? We've got it. This week's newest movies, last night's TV shows, classic favorites, and more are available to stream instantly, plus all your videos are stored in Your Video Library. Over 150,000 movies and TV episodes, including thousands for Amazon Prime members at no additional cost.\r\n \r\nGet More Prime Video: \r\nStream Now: http://bit.ly/WatchMorePrimeVideo\r\nFacebook: http://bit.ly/PrimeVideoFB\r\nTwitter: http://bit.ly/PrimeVideoTW\r\nInstagram: http://bit.ly/AmazonPrimeVideoIG\r\n \r\nPrime Video\r\nhttps://www.youtube.com/PrimeVideo",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/sY8gUtyeAKE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/sY8gUtyeAKE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/sY8gUtyeAKE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/sY8gUtyeAKE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/sY8gUtyeAKE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Amazon Prime Video",
          "tags": [
            "coming to america",
            "coming 2 america",
            "coming 2 america trailer",
            "coming to america 2",
            "coming to america 2 trailer",
            "coming to america trailer",
            "trailer",
            "official trailer",
            "official trailer 2021",
            "trailer 2021",
            "eddie murphy coming to america",
            "eddie murphy coming to america 2",
            "arsenio hall",
            "arsenio hall coming to america",
            "arsenio hall coming to america 2",
            "james earl jones",
            "james earl jones coming to america",
            "james earl jones coming to america 2",
            "amazon",
            "amazon prime video",
            "prime video"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Coming 2 America - Official Trailer",
            "description": "Set in the lush and royal country of Zamunda, newly-crowned King Akeem (Eddie Murphy) and his trusted confidante Semmi(Arsenio Hall) embark on an all-new hilarious adventure that has them traversing the globe from their great African nation to the borough of Queens, New York – where it all began. Available March 5th on Prime Video. Starring: Eddie Murphy, Arsenio Hall, Jermaine Fowler, Leslie Jones, Tracy Morgan, KiKi Layne, Shari Headley, with Wesley Snipes and James Earl Jones. Also starring John Amos, Teyana Taylor, Vanessa Bell Calloway, Paul Bates, Nomzamo Mbatha, Bella Murphy Screenplay by: Kenya Barris and Barry W. Blaustein & David Sheffield Story by: Barry W. Blaustein & David Sheffield and Justin Kanew Directed by: Craig Brewer Based on characters created by: Eddie Murphy Produced by: Kevin Misher and Eddie Murphy Costumes by: Ruth E. Carter.\n\n» SUBSCRIBE: http://bit.ly/PrimeVideoSubscribe\r\n \r\nAbout Prime Video:\r\nWant to watch it now? We've got it. This week's newest movies, last night's TV shows, classic favorites, and more are available to stream instantly, plus all your videos are stored in Your Video Library. Over 150,000 movies and TV episodes, including thousands for Amazon Prime members at no additional cost.\r\n \r\nGet More Prime Video: \r\nStream Now: http://bit.ly/WatchMorePrimeVideo\r\nFacebook: http://bit.ly/PrimeVideoFB\r\nTwitter: http://bit.ly/PrimeVideoTW\r\nInstagram: http://bit.ly/AmazonPrimeVideoIG\r\n \r\nPrime Video\r\nhttps://www.youtube.com/PrimeVideo"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT2M1S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "4001661",
          "likeCount": "56744",
          "dislikeCount": "1720",
          "favoriteCount": "0",
          "commentCount": "5817"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "So8oXt3GUtL5PR4UXNiOHQRkoF4",
        "id": "EmrMT9Vx42E",
        "snippet": {
          "publishedAt": "2020-12-23T02:31:24Z",
          "channelId": "UCWJ2lWNubArHWmf3FIHbfcQ",
          "title": "WARRIORS at NETS | FULL GAME HIGHLIGHTS | December 22, 2020",
          "description": "WARRIORS at NETS | FULL GAME HIGHLIGHTS | December 22, 2020\n\nKyrie Irving (26 PTS, 4 AST, 4 3PM) and the Brooklyn Nets scored 40 PTS in the first quarter and never looked back as they picked up their first win of the season over the Golden State Warriors, 125-99, during #KiaTipOff20. In his regular season debut for Brooklyn, Kevin Durant tallied 22 PTS, 5 REB, 3 AST, while Caris LeVert provided 20 PTS, 9 REB and 5 AST off the bench for the Nets. Stephen Curry led the Warriors in scoring with a 20-PT, 10 AST double-double, and the No. 2 pick in the 2020 Draft James Wiseman recorded 19 PTS and 6 REB in his Golden State debut.\n\nNext Games:\nGolden State Warriors at Milwaukee Bucks – Dec. 25 at 2:30pm/et on ABC\nBrooklyn Nets at Boston Celtics – Dec. 25 at 5pm/et on ABC\n\nSubscribe to the NBA: https://on.nba.com/2JX5gSN \r\n\nFull Game Highlights Playlist: https://on.nba.com/2rjGMge\r\n\nFor news, stories, highlights and more, go to our official website at https://nba_webonly.app.link/nbasite\r\n\nGet NBA LEAGUE PASS: https://nba.app.link/nbaleaguepass5",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/EmrMT9Vx42E/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/EmrMT9Vx42E/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/EmrMT9Vx42E/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/EmrMT9Vx42E/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/EmrMT9Vx42E/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "NBA",
          "tags": [
            "NBA",
            "G League",
            "Basketball",
            "game-0022000001",
            "Pass",
            "Assist",
            "Dunk",
            "Jump Shot",
            "Steal",
            "Rebound",
            "Offense",
            "Defense",
            "Three",
            "Three-Pointer",
            "Triple",
            "Mid-Range",
            "Jumper",
            "Fadeaway",
            "Highlight",
            "Highlights",
            "Play",
            "Plays",
            "NBA Season",
            "2020-21 Season",
            "Full Game Highlights",
            "Full Game Recap",
            "Nets",
            "Warriors",
            "KD",
            "Kyrie"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "WARRIORS at NETS | FULL GAME HIGHLIGHTS | December 22, 2020",
            "description": "WARRIORS at NETS | FULL GAME HIGHLIGHTS | December 22, 2020\n\nKyrie Irving (26 PTS, 4 AST, 4 3PM) and the Brooklyn Nets scored 40 PTS in the first quarter and never looked back as they picked up their first win of the season over the Golden State Warriors, 125-99, during #KiaTipOff20. In his regular season debut for Brooklyn, Kevin Durant tallied 22 PTS, 5 REB, 3 AST, while Caris LeVert provided 20 PTS, 9 REB and 5 AST off the bench for the Nets. Stephen Curry led the Warriors in scoring with a 20-PT, 10 AST double-double, and the No. 2 pick in the 2020 Draft James Wiseman recorded 19 PTS and 6 REB in his Golden State debut.\n\nNext Games:\nGolden State Warriors at Milwaukee Bucks – Dec. 25 at 2:30pm/et on ABC\nBrooklyn Nets at Boston Celtics – Dec. 25 at 5pm/et on ABC\n\nSubscribe to the NBA: https://on.nba.com/2JX5gSN \r\n\nFull Game Highlights Playlist: https://on.nba.com/2rjGMge\r\n\nFor news, stories, highlights and more, go to our official website at https://nba_webonly.app.link/nbasite\r\n\nGet NBA LEAGUE PASS: https://nba.app.link/nbaleaguepass5"
          }
        },
        "contentDetails": {
          "duration": "PT9M41S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "regionRestriction": {
            "allowed": [
              "PH",
              "IN",
              "US",
              "CA"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2130724",
          "likeCount": "24416",
          "dislikeCount": "883",
          "favoriteCount": "0",
          "commentCount": "4628"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "69Md6MFEbL7jj6fzGLGby_fyDDA",
        "id": "Ty-CHgmCeKw",
        "snippet": {
          "publishedAt": "2020-12-21T05:00:10Z",
          "channelId": "UCaxOQZrF5llUMp-JjesUz1A",
          "title": "Lil Durk - Backdoor (Official Music Video)",
          "description": "Stream: https://smarturl.it/BackdoorDurk\n\nShot by @JerryPHD\n\nFollow Lil Durk:\nhttps://instagram.com/durkioworld\nhttps://twitter.com/lildurk\nhttps://fb.com/lildurk\nhttps://soundcloud.com/lildurk\nhttp://officiallildurk.com\n\nSubscribe to Lil Durk's official channel for exclusive music videos and behind the scenes looks: http://bit.ly/Subscribe-to-Durk\n\n#lildurk #otf #backdoor",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/Ty-CHgmCeKw/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/Ty-CHgmCeKw/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/Ty-CHgmCeKw/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/Ty-CHgmCeKw/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/Ty-CHgmCeKw/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Lil Durk",
          "tags": [
            "lil durk",
            "lil durk music",
            "lil durk music video",
            "just cause yall waited 2",
            "lil durk 2020",
            "just cause y'all waited 2",
            "durkio",
            "smurkio",
            "lil durk official",
            "drill",
            "drill music",
            "chicago hip hop",
            "only the family",
            "OTF",
            "backdoor",
            "back door",
            "king von",
            "von"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Lil Durk - Backdoor (Official Music Video)",
            "description": "Stream: https://smarturl.it/BackdoorDurk\n\nShot by @JerryPHD\n\nFollow Lil Durk:\nhttps://instagram.com/durkioworld\nhttps://twitter.com/lildurk\nhttps://fb.com/lildurk\nhttps://soundcloud.com/lildurk\nhttp://officiallildurk.com\n\nSubscribe to Lil Durk's official channel for exclusive music videos and behind the scenes looks: http://bit.ly/Subscribe-to-Durk\n\n#lildurk #otf #backdoor"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT3M33S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "4426792",
          "likeCount": "206175",
          "dislikeCount": "5130",
          "favoriteCount": "0",
          "commentCount": "19318"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Iw0iwSWRXtMlDHjLYDuHPEW4raQ",
        "id": "uuodbSVO3z0",
        "snippet": {
          "publishedAt": "2020-12-22T20:00:09Z",
          "channelId": "UCSaPKJpNd-Mkm6hhelIYSlQ",
          "title": "POP SMOKE - WHAT YOU KNOW BOUT LOVE (Official Video)",
          "description": "What You Know Bout Love - (Official Video) by Pop Smoke\nDownload here: https://popsmoke.lnk.to/SFTSAFTM\n \nSubscribe to Pop Smoke’s channel:\nhttps://PopSmoke.lnk.to/Subscribe   \n\nNew Merch: shop.realpopsmoke.com\n\nFollow Pop Smoke:\nhttps://instagram.com/RealPopSmoke  \nhttps://instagram.com/ShootForTheStars  \n\nDirector: Oliver Cannon\nProducers: Shivam Pandya & Xiarra Diamond\nVideo Editor: Jasper Graham\nProduction Company: Victor Victor Worldwide\n\nLyrics: \nShawty go jogging every morning (every morning)\nAnd she make me breakfast almost every morning (every morning)\nAnd she take a naked pic' before she leave the door\nI be waking up to pics' before a nigga yawning\nAnd every weekend my shawty comin' over (over)\nShawty could Fendi out, but she like Fashion Nova (Nova)\nShe ain't driving no Camry, she pullin' in a Rover (Rover)\nWith her hair so curly, I love you, baby\nShe said, \"What you know 'bout love?\" (I'll tell you everything)\nI got what you need (oh)\nWalk up in the store and get what you want (go get it)\nYou get what you please\nWe 'bout to get it on, take off them drawers (I said I love you, baby)\nIt's just you and me\nYou know what I be on, I'm about to go raw (love you, baby)\n'Cause I like what I see\nLook, baby, I said I ain't gon' front\nYou got my heart beating so fast to words I can't pronounce\nAnd I be getting the chills every time I feel your touch\nI be looking at the top and girl, it's only us\nAll I need is your trust\nAnd girl I told you once, don't make me tell you twice\n\nI know you see this print through my pants that I know you like\nAnd yo' ass be looking so fat when it be in them tights\nAnd I'm going straight to the top, so hope you ain't afraid of heights\nYou always treat me right, for a fact, you never left\nThrough all the trials and tribulations, always had my best\nSo here's 55 hunnid, go and get your breasts\nStart rubbin' on your butt, start kissing on yo' neck\nHey batter, batter, hey batter, batter\nNiggas know I had to swing, I had to make a play\nI had to apply the pressure, 'cause you my hidden treasure\nI think I'm falling in love\nShe said, \"What you know 'bout love?\" (I'll tell you everything)\nI got what you need (oh)\nWalk up in the store and get what you want (go get it)\nYou get what you please\nWe 'bout to get it on, take off them drawers (I said I love you, baby)\nIt's just you and me\nYou know what I be on, I'm about to go raw (love you, baby)\n'Cause I like what I see (oh)\n\n#PopSmoke #WhatYouKnowBoutLove #WYKBL",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/uuodbSVO3z0/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/uuodbSVO3z0/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/uuodbSVO3z0/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/uuodbSVO3z0/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/uuodbSVO3z0/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "POP SMOKE",
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "POP SMOKE - WHAT YOU KNOW BOUT LOVE (Official Video)",
            "description": "What You Know Bout Love - (Official Video) by Pop Smoke\nDownload here: https://popsmoke.lnk.to/SFTSAFTM\n \nSubscribe to Pop Smoke’s channel:\nhttps://PopSmoke.lnk.to/Subscribe   \n\nNew Merch: shop.realpopsmoke.com\n\nFollow Pop Smoke:\nhttps://instagram.com/RealPopSmoke  \nhttps://instagram.com/ShootForTheStars  \n\nDirector: Oliver Cannon\nProducers: Shivam Pandya & Xiarra Diamond\nVideo Editor: Jasper Graham\nProduction Company: Victor Victor Worldwide\n\nLyrics: \nShawty go jogging every morning (every morning)\nAnd she make me breakfast almost every morning (every morning)\nAnd she take a naked pic' before she leave the door\nI be waking up to pics' before a nigga yawning\nAnd every weekend my shawty comin' over (over)\nShawty could Fendi out, but she like Fashion Nova (Nova)\nShe ain't driving no Camry, she pullin' in a Rover (Rover)\nWith her hair so curly, I love you, baby\nShe said, \"What you know 'bout love?\" (I'll tell you everything)\nI got what you need (oh)\nWalk up in the store and get what you want (go get it)\nYou get what you please\nWe 'bout to get it on, take off them drawers (I said I love you, baby)\nIt's just you and me\nYou know what I be on, I'm about to go raw (love you, baby)\n'Cause I like what I see\nLook, baby, I said I ain't gon' front\nYou got my heart beating so fast to words I can't pronounce\nAnd I be getting the chills every time I feel your touch\nI be looking at the top and girl, it's only us\nAll I need is your trust\nAnd girl I told you once, don't make me tell you twice\n\nI know you see this print through my pants that I know you like\nAnd yo' ass be looking so fat when it be in them tights\nAnd I'm going straight to the top, so hope you ain't afraid of heights\nYou always treat me right, for a fact, you never left\nThrough all the trials and tribulations, always had my best\nSo here's 55 hunnid, go and get your breasts\nStart rubbin' on your butt, start kissing on yo' neck\nHey batter, batter, hey batter, batter\nNiggas know I had to swing, I had to make a play\nI had to apply the pressure, 'cause you my hidden treasure\nI think I'm falling in love\nShe said, \"What you know 'bout love?\" (I'll tell you everything)\nI got what you need (oh)\nWalk up in the store and get what you want (go get it)\nYou get what you please\nWe 'bout to get it on, take off them drawers (I said I love you, baby)\nIt's just you and me\nYou know what I be on, I'm about to go raw (love you, baby)\n'Cause I like what I see (oh)\n\n#PopSmoke #WhatYouKnowBoutLove #WYKBL"
          }
        },
        "contentDetails": {
          "duration": "PT2M49S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "773731",
          "likeCount": "120880",
          "dislikeCount": "352",
          "favoriteCount": "0",
          "commentCount": "9488"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "l4HocT4pC0N5qlgM-4a6o4IL_U4",
        "id": "kr0KFUaUvRY",
        "snippet": {
          "publishedAt": "2020-12-23T03:30:02Z",
          "channelId": "UChnGFN2LRHBq-0PM6dOaq5A",
          "title": "Tayshia & Zac Get Engaged! 💍 | The Bachelorette",
          "description": "It's the moment we've all been waiting for, the grand finale of Tayshia's Bachelorette is here. Zac is the lucky guy who gets down on one knee and proposes to Tayshia. Congratulations to the happy couple. 🥰\n\n➤ Subscribe ➤ http://bit.ly/BacheIorNation\n\n#TheBachelorette #TayshiaAdams #Bachelorette\nSeason: 16  Episode: 13\nBachelorette: Tayshia Adams\n\n➤ Watch #Tayshia's Bachelorette journey here ➤ http://bit.ly/TayshiaAdams\n\n➤ Want more #ClareCrawley? Watch her whirlwind romance here ➤ http://bit.ly/ClareCrawley\n\n➤ Check out The Bachelorette Australia right here  ➤ http://bit.ly/TheBacheloretteAU\n\nWelcome to Bachelor Nation! Here you'll find your favourite Bachelor, Bachelorette and Bachelor In Paradise moments from all around the world. Thought The Bachelor was just a US phenomenon? Think again! The romance, glamour and heart-ache may have started in the States, but the love-bug soon spread around the globe, from Australia and Canada, to the UK, New Zealand and beyond! Bachelor Nation is here to share the fan favourite and memorable moments from over 1000 episodes and 30 countries - Will you accept this rose? 🌹\n\nHead to http://www.bachelornation.com for news, photos, updates, and more from the Bachelor franchise.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/kr0KFUaUvRY/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/kr0KFUaUvRY/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/kr0KFUaUvRY/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/kr0KFUaUvRY/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/kr0KFUaUvRY/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Bachelor Nation",
          "tags": [
            "bachelorette",
            "the bachelorette",
            "bachelorette 2020",
            "the bachelorette 2020",
            "clare crawley",
            "bachelor nation",
            "clare crawley dale moss",
            "bachelorette abc",
            "clare crawley bachelorette",
            "bachelorette clare",
            "watch the bachelorette",
            "dale and clare",
            "watch bachelorette",
            "clare and dale",
            "bachelor",
            "bachelor abc",
            "bachelor live stream",
            "Clare crawley interview",
            "dale moss",
            "tayshia adams",
            "tayshia",
            "bachelorette tayshia",
            "tayshia bachelorette",
            "tashia",
            "taysha"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en-US",
          "localized": {
            "title": "Tayshia & Zac Get Engaged! 💍 | The Bachelorette",
            "description": "It's the moment we've all been waiting for, the grand finale of Tayshia's Bachelorette is here. Zac is the lucky guy who gets down on one knee and proposes to Tayshia. Congratulations to the happy couple. 🥰\n\n➤ Subscribe ➤ http://bit.ly/BacheIorNation\n\n#TheBachelorette #TayshiaAdams #Bachelorette\nSeason: 16  Episode: 13\nBachelorette: Tayshia Adams\n\n➤ Watch #Tayshia's Bachelorette journey here ➤ http://bit.ly/TayshiaAdams\n\n➤ Want more #ClareCrawley? Watch her whirlwind romance here ➤ http://bit.ly/ClareCrawley\n\n➤ Check out The Bachelorette Australia right here  ➤ http://bit.ly/TheBacheloretteAU\n\nWelcome to Bachelor Nation! Here you'll find your favourite Bachelor, Bachelorette and Bachelor In Paradise moments from all around the world. Thought The Bachelor was just a US phenomenon? Think again! The romance, glamour and heart-ache may have started in the States, but the love-bug soon spread around the globe, from Australia and Canada, to the UK, New Zealand and beyond! Bachelor Nation is here to share the fan favourite and memorable moments from over 1000 episodes and 30 countries - Will you accept this rose? 🌹\n\nHead to http://www.bachelornation.com for news, photos, updates, and more from the Bachelor franchise."
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT5M17S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "188021",
          "likeCount": "5713",
          "dislikeCount": "98",
          "favoriteCount": "0",
          "commentCount": "939"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Gxn9Yl6-5VFiyUr4N7lI8rhRep8",
        "id": "w-G39yJCHeA",
        "snippet": {
          "publishedAt": "2020-12-21T18:00:45Z",
          "channelId": "UCsEgeyBfOnGGBpjIvkDJbWg",
          "title": "among us NEW DOCTOR ROLE (mods)",
          "description": "today in among us we added a doctor role (revive players) \n\nPrevious Video →https://www.youtube.com/watch?v=ne0WPNUNe8M\n\n#amongus\n#Mod\n\nFriends (sub to them) \nFatmemegod- https://bit.ly/33oDf0G\nBlaza-https://bit.ly/3cWCMGj\nJuice- https://bit.ly/3oga4EN\nNadwe- https://bit.ly/3mmpJ4O\n\n⛏️JOIN SERVER → socks.gg \nuse code \"Socksfor1\" in the item shop ad\n😀TIKTOK→ https://bit.ly/2UynFdt\n👽REDDIT → https://bit.ly/3ejZBmf\n🔴TWITCH → https://bit.ly/3iSmkcq\n📷INSTAGRAM → https://bit.ly/38KFjRA \n🐦TWITTER → https://bit.ly/2Oi0YHC\n👕NEW MERCH → https://bit.ly/2AThH0O\n🎥2ND CHANNEL → https://bit.ly/38Kb6SQ \n😀DISCORD → https://bit.ly/2ZXonUc\n\nMUSIC → https://bit.ly/3edT2Sc (Kevin MacLeod)\n→ https://bit.ly/3kdvbVY (Epidemic) \nOUTRO → https://bit.ly/2DoKefp\nMODPACK → \nEDITOR → praduh\nEMAIL→ nicholas@socksfor1.com\n\nFamily Friendly PG Clean 13+",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/w-G39yJCHeA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/w-G39yJCHeA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/w-G39yJCHeA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/w-G39yJCHeA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/w-G39yJCHeA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Socksfor1",
          "tags": [
            "Socksfor1",
            "among us",
            "among us mods",
            "socksfor1 mods",
            "among us NEW DOCTOR ROLE (mods)",
            "among us roles",
            "among us medic",
            "among us revive players",
            "among us impostor",
            "among us impostor iq players",
            "among us update",
            "among us termiantor",
            "among us but the impostor can drag bodies",
            "among us new update"
          ],
          "categoryId": "20",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "among us NEW DOCTOR ROLE (mods)",
            "description": "today in among us we added a doctor role (revive players) \n\nPrevious Video →https://www.youtube.com/watch?v=ne0WPNUNe8M\n\n#amongus\n#Mod\n\nFriends (sub to them) \nFatmemegod- https://bit.ly/33oDf0G\nBlaza-https://bit.ly/3cWCMGj\nJuice- https://bit.ly/3oga4EN\nNadwe- https://bit.ly/3mmpJ4O\n\n⛏️JOIN SERVER → socks.gg \nuse code \"Socksfor1\" in the item shop ad\n😀TIKTOK→ https://bit.ly/2UynFdt\n👽REDDIT → https://bit.ly/3ejZBmf\n🔴TWITCH → https://bit.ly/3iSmkcq\n📷INSTAGRAM → https://bit.ly/38KFjRA \n🐦TWITTER → https://bit.ly/2Oi0YHC\n👕NEW MERCH → https://bit.ly/2AThH0O\n🎥2ND CHANNEL → https://bit.ly/38Kb6SQ \n😀DISCORD → https://bit.ly/2ZXonUc\n\nMUSIC → https://bit.ly/3edT2Sc (Kevin MacLeod)\n→ https://bit.ly/3kdvbVY (Epidemic) \nOUTRO → https://bit.ly/2DoKefp\nMODPACK → \nEDITOR → praduh\nEMAIL→ nicholas@socksfor1.com\n\nFamily Friendly PG Clean 13+"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT13M2S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "4840243",
          "likeCount": "136285",
          "dislikeCount": "4080",
          "favoriteCount": "0",
          "commentCount": "9103"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Mxq63_hOBanpEsIMgbhT-fuzxHw",
        "id": "o2boz3JRhuE",
        "snippet": {
          "publishedAt": "2020-12-23T01:00:20Z",
          "channelId": "UCkzCjdRMrW2vXLx8mvPVLdQ",
          "title": "HIGHLIGHTS | ARSENAL 1-4 MAN CITY | CARABAO CUP",
          "description": "Holders Manchester City produced another Carabao Cup masterclass as we secured a comprehensive last-eight victory over Arsenal in North London to march into the semi-finals.\n\nSecond-half strikes from Riyad Mahrez, Phil Foden and Aymeric Laporte made it a night to remember after Gabriel Jesus’s third-minute opener had been cancelled out before the break.\n\nThe victory further extended manager Pep Guardiola’s incredible record in the League Cup and was no less than we deserved after what was another impressive all-round display.\n\nMatch report: https://www.mancity.com/news/mens/arsenal-v-manchester-city-carabao-cup-report-63744261\n\nSUBSCRIBE! http://www.youtube.com/subscription_center?add_user=mancity\r\n\r\nhttp://www.mancity.com\r\nhttp://www.facebook.com/mancity\r\nhttp://www.twitter.com/mancity\r\nhttp://www.instagram.com/mancity\r\nhttps://www.snapchat.com/add/mancityofficial\r\n\r\nAbout the Official Man City YouTube Channel:\r\n\r\nHere you will find all the latest videos from Manchester City, including, all Premier League goals, highlights, behind-the-scenes footage, training and much more.\r\n\r\nGet closer to the likes of Sergio Aguero, Kevin De Bruyne, Gabriel Jesus, Raheem Sterling, Riyad Mahrez, Benjamin Mendy and the rest of Pep Guardiola's team.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/o2boz3JRhuE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/o2boz3JRhuE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/o2boz3JRhuE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/o2boz3JRhuE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/o2boz3JRhuE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Man City",
          "tags": [
            "man city",
            "manchester city",
            "arsenal vs man cityman city",
            "arsenal v manchester city",
            "arsenal v city",
            "arsenal 1-4 man city",
            "arsenal 1-4 manchester city",
            "arsenal 1-4 city",
            "man city highlights",
            "arsenal highlights",
            "man city carabao cup",
            "man city league cup",
            "arsenal fan tv",
            "aymeric laporte",
            "phil foden",
            "riyad mahrez",
            "gabriel jesus",
            "laporte goal",
            "foden goal",
            "mahrez goal",
            "jesus goal",
            "man city tujuan",
            "manchester city tujuan"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en-GB",
          "localized": {
            "title": "HIGHLIGHTS | ARSENAL 1-4 MAN CITY | CARABAO CUP",
            "description": "Holders Manchester City produced another Carabao Cup masterclass as we secured a comprehensive last-eight victory over Arsenal in North London to march into the semi-finals.\n\nSecond-half strikes from Riyad Mahrez, Phil Foden and Aymeric Laporte made it a night to remember after Gabriel Jesus’s third-minute opener had been cancelled out before the break.\n\nThe victory further extended manager Pep Guardiola’s incredible record in the League Cup and was no less than we deserved after what was another impressive all-round display.\n\nMatch report: https://www.mancity.com/news/mens/arsenal-v-manchester-city-carabao-cup-report-63744261\n\nSUBSCRIBE! http://www.youtube.com/subscription_center?add_user=mancity\r\n\r\nhttp://www.mancity.com\r\nhttp://www.facebook.com/mancity\r\nhttp://www.twitter.com/mancity\r\nhttp://www.instagram.com/mancity\r\nhttps://www.snapchat.com/add/mancityofficial\r\n\r\nAbout the Official Man City YouTube Channel:\r\n\r\nHere you will find all the latest videos from Manchester City, including, all Premier League goals, highlights, behind-the-scenes footage, training and much more.\r\n\r\nGet closer to the likes of Sergio Aguero, Kevin De Bruyne, Gabriel Jesus, Raheem Sterling, Riyad Mahrez, Benjamin Mendy and the rest of Pep Guardiola's team."
          },
          "defaultAudioLanguage": "en-GB"
        },
        "contentDetails": {
          "duration": "PT8M4S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1845617",
          "likeCount": "32171",
          "dislikeCount": "1259",
          "favoriteCount": "0",
          "commentCount": "2338"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "wLuRk10Mvlmt9jWNTPz7ltMFPQQ",
        "id": "WQ8Xgp8ALFo",
        "snippet": {
          "publishedAt": "2020-12-22T16:07:20Z",
          "channelId": "UCj1VqrHhDte54oLgPG4xpuQ",
          "title": "Robot Barber V2. Just mess my stuff up.",
          "description": "The first 1000 people to use this link will get a free trial of Skillshare Premium Membership: https://skl.sh/stuffmadehere12201\nPlease consider supporting these projects through my patreon: http://patreon.com/stuffmadehere Although very fun, these videos are very time consuming and expensive.\nI use a glowforge pro for rapid prototyping and it's great. You can $500 off a Glowforge pro here: http://glowforge.com/stuffmadehere \n\n-----------\n\nIt was time to take another pass on the hair cutting robot. The new robot is bigger, better, way more reliable and travel friendly. I tried to cut MatPats hair (live) then my brothers hair and then my own. For some reason I'm compelled to improve the pattern carving functionality even though I have zero desire to actually use it....\n\nOne final thing - if you know of any actual problems that could use a better solution please leave a comment. One of my goals is to make a portion of my projects attempts at solving legitimately useful problems and I would love to have a good list of them. Thanks!",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/WQ8Xgp8ALFo/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/WQ8Xgp8ALFo/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/WQ8Xgp8ALFo/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/WQ8Xgp8ALFo/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/WQ8Xgp8ALFo/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Stuff Made Here",
          "tags": [
            "stuff made here",
            "haircut robot",
            "invention",
            "quarantine haircut",
            "robotics",
            "engineering",
            "incredible inventions"
          ],
          "categoryId": "28",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Robot Barber V2. Just mess my stuff up.",
            "description": "The first 1000 people to use this link will get a free trial of Skillshare Premium Membership: https://skl.sh/stuffmadehere12201\nPlease consider supporting these projects through my patreon: http://patreon.com/stuffmadehere Although very fun, these videos are very time consuming and expensive.\nI use a glowforge pro for rapid prototyping and it's great. You can $500 off a Glowforge pro here: http://glowforge.com/stuffmadehere \n\n-----------\n\nIt was time to take another pass on the hair cutting robot. The new robot is bigger, better, way more reliable and travel friendly. I tried to cut MatPats hair (live) then my brothers hair and then my own. For some reason I'm compelled to improve the pattern carving functionality even though I have zero desire to actually use it....\n\nOne final thing - if you know of any actual problems that could use a better solution please leave a comment. One of my goals is to make a portion of my projects attempts at solving legitimately useful problems and I would love to have a good list of them. Thanks!"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT22M",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "856358",
          "likeCount": "58149",
          "dislikeCount": "500",
          "favoriteCount": "0",
          "commentCount": "4239"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "oE6RnwUZ6U0_V_xDydM3ddzaNPk",
        "id": "XrRcfaWutLQ",
        "snippet": {
          "publishedAt": "2020-12-22T02:45:05Z",
          "channelId": "UC4zmFY211sXfEamwmsJcrYA",
          "title": "LIVE! See the Great Conjunction (Christmas Star) of 2020",
          "description": "*Update 12/21: Skies are perfectly clear here in Flagstaff, Arizona! Below is tonight's Great Conjunction Program Schedule (all times MST; schedule subject to change).\n\n0:00:00 | Dr. Jeff Hall, Lowell Observatory Director: Welcome\n00:04:31 | Dr. Michael West, astronomer: Winter and Summer Solstice Around the World \n00:24:24 | Jos Schindler, educator: Introduction to the 2020 Great Conjunction\n00:46:08 | Dr. Jennifer Hanley, planetary scientist: The Icy Moons of Jupiter and Saturn\n01:07:45 | Dr. Larry Wasserman, planetary scientist: Thoughts on This (and Other) Great Conjunctions\n01:23:42 | Jos Schindler, educator: Recap of the 2020 Great Conjunction\n01:32:10 | Dr. Joe Llama, astronomer: Conjunctions in Other Planetary Systems\n01:49:09 | Kevin Schindler, historian: Historic Conjunctions and the Christmas Star \n02:09:37 | Dr. Nick Moskovitz, planetary scientist: Ursids Meteor Shower\n02:28:21 | Dr. Jeff Hall, Lowell Observatory Director: Closing Remarks\n\nOnce every 20 years, the two largest planets in our solar system—Jupiter and Saturn—appear to meet in Earth’s skies. This “Great Conjunction” happens next on December 21, 2020, but this time, Jupiter and Saturn will be closer than they’ve been in nearly 400 years.  December 21 also happens to be the night of the winter solstice, and the peak of the Ursid meteor shower. \n\nFor most Great Conjunctions, Jupiter and Saturn are separated by about 1 degree, which is the width of two full moons in the sky. This year, they will be separated by just one-tenth of a degree, which is one-fifth the size of the full moon. A Great Conjunction happens every 20 years, but the last time Jupiter and Saturn were this close was the year 1623.\n\nJoin Lowell Observatory at 5pm MST on Monday, December 21, 2020, to celebrate the Great Conjunction with an evening of telescope viewing and commentary from Lowell's own astronomers and educators.\n\n#ChristmasStar",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/XrRcfaWutLQ/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/XrRcfaWutLQ/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/XrRcfaWutLQ/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/XrRcfaWutLQ/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/XrRcfaWutLQ/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Lowell Observatory",
          "tags": [
            "Lowell Observatory",
            "Giovale Open Deck Observatory",
            "astronomy",
            "stargazing",
            "telescopes",
            "Stargazing",
            "Live",
            "Leonids",
            "Leonids Meteor Shower",
            "ChristmasStar"
          ],
          "categoryId": "28",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "LIVE! See the Great Conjunction (Christmas Star) of 2020",
            "description": "*Update 12/21: Skies are perfectly clear here in Flagstaff, Arizona! Below is tonight's Great Conjunction Program Schedule (all times MST; schedule subject to change).\n\n0:00:00 | Dr. Jeff Hall, Lowell Observatory Director: Welcome\n00:04:31 | Dr. Michael West, astronomer: Winter and Summer Solstice Around the World \n00:24:24 | Jos Schindler, educator: Introduction to the 2020 Great Conjunction\n00:46:08 | Dr. Jennifer Hanley, planetary scientist: The Icy Moons of Jupiter and Saturn\n01:07:45 | Dr. Larry Wasserman, planetary scientist: Thoughts on This (and Other) Great Conjunctions\n01:23:42 | Jos Schindler, educator: Recap of the 2020 Great Conjunction\n01:32:10 | Dr. Joe Llama, astronomer: Conjunctions in Other Planetary Systems\n01:49:09 | Kevin Schindler, historian: Historic Conjunctions and the Christmas Star \n02:09:37 | Dr. Nick Moskovitz, planetary scientist: Ursids Meteor Shower\n02:28:21 | Dr. Jeff Hall, Lowell Observatory Director: Closing Remarks\n\nOnce every 20 years, the two largest planets in our solar system—Jupiter and Saturn—appear to meet in Earth’s skies. This “Great Conjunction” happens next on December 21, 2020, but this time, Jupiter and Saturn will be closer than they’ve been in nearly 400 years.  December 21 also happens to be the night of the winter solstice, and the peak of the Ursid meteor shower. \n\nFor most Great Conjunctions, Jupiter and Saturn are separated by about 1 degree, which is the width of two full moons in the sky. This year, they will be separated by just one-tenth of a degree, which is one-fifth the size of the full moon. A Great Conjunction happens every 20 years, but the last time Jupiter and Saturn were this close was the year 1623.\n\nJoin Lowell Observatory at 5pm MST on Monday, December 21, 2020, to celebrate the Great Conjunction with an evening of telescope viewing and commentary from Lowell's own astronomers and educators.\n\n#ChristmasStar"
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT2H32M10S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2197690",
          "likeCount": "31678",
          "dislikeCount": "621",
          "favoriteCount": "0",
          "commentCount": "524"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "4Rj0_HvW3ga_1Ecb1jzSypa0ATM",
        "id": "QbLjGlt7Z2s",
        "snippet": {
          "publishedAt": "2020-12-22T23:22:32Z",
          "channelId": "UC0YatYmg5JRYzXJPxIdRd8g",
          "title": "Valladolid 0 - 3 Barcelona - HIGHLIGHTS & GOALS - 12/22/2020",
          "description": "With Messi as the lead of the attack, Barcelona was able to neutralize and disarm Valladolid easily. Though the goals could've come in major quantities, Messi will definitely remember this game as he broke yet another record.\n\nConnect with beIN SPORTS Online:\nWatch us on TV: http://bit.ly/2d7bf5Y\nWatch us Online: http://bit.ly/1WNtvkc\nVisit our WEBSITE: http://beINSPORTS.com\nLike us on FACEBOOK: http://facebook.com/beINSPORTSUSA\nFollow us on TWITTER: http://twitter.com/beINSPORTSUSA\nFollow us on INSTAGRAM: http://instagram.com/beINSPORTSUSA\n#LaLiga #ValladolidBarça #Messi",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/QbLjGlt7Z2s/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/QbLjGlt7Z2s/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/QbLjGlt7Z2s/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/QbLjGlt7Z2s/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/QbLjGlt7Z2s/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "beIN SPORTS USA",
          "tags": [
            "beIN SPORTS",
            "beIN SPORTS USA",
            "Futbol",
            "Football",
            "LaLiga",
            "La Liga",
            "Valladolid",
            "Barcelona",
            "Jose Zorrilla",
            "Messi",
            "Lenglet",
            "Braithwaite"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Valladolid 0 - 3 Barcelona - HIGHLIGHTS & GOALS - 12/22/2020",
            "description": "With Messi as the lead of the attack, Barcelona was able to neutralize and disarm Valladolid easily. Though the goals could've come in major quantities, Messi will definitely remember this game as he broke yet another record.\n\nConnect with beIN SPORTS Online:\nWatch us on TV: http://bit.ly/2d7bf5Y\nWatch us Online: http://bit.ly/1WNtvkc\nVisit our WEBSITE: http://beINSPORTS.com\nLike us on FACEBOOK: http://facebook.com/beINSPORTSUSA\nFollow us on TWITTER: http://twitter.com/beINSPORTSUSA\nFollow us on INSTAGRAM: http://instagram.com/beINSPORTSUSA\n#LaLiga #ValladolidBarça #Messi"
          }
        },
        "contentDetails": {
          "duration": "PT9M28S",
          "dimension": "2d",
          "definition": "sd",
          "caption": "false",
          "licensedContent": true,
          "regionRestriction": {
            "allowed": [
              "US",
              "PR",
              "CA"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "342841",
          "likeCount": "4202",
          "dislikeCount": "92",
          "favoriteCount": "0",
          "commentCount": "1004"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "abJKLsVeed4K10qKZv7ctKoqLmU",
        "id": "1EfkVEBvB40",
        "snippet": {
          "publishedAt": "2020-12-23T06:05:56Z",
          "channelId": "UCU7iRrk3xfpUk0R6VdyC1Ow",
          "title": "Do NBA Superstars Get Preferential Treatment? | NBA on TNT",
          "description": "After the Lakers-Clippers game, Shaq, Chuck and Kenny debate if NBA stars get preferential treatment and the side effects that can cause in a locker room. \n\nWatch highlights from Inside the NBA with Shaq, Charles Barkley, Kenny Smith and Ernie Johnson and more! Subscribe now to be updated on the latest videos: https://www.youtube.com/nbaontnt?sub_confirmation=1\r\n\r\nConnect with NBA on TNT:\r\nFollow NBA on TNT on Twitter: https://twitter.com/NBAonTNT\r\nLike NBA on TNT on Facebook: https://www.facebook.com/NBAONTNT/\r\nFollow NBA on TNT on Instagram: https://www.instagram.com/nbaontnt/?hl=en",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/1EfkVEBvB40/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/1EfkVEBvB40/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/1EfkVEBvB40/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/1EfkVEBvB40/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/1EfkVEBvB40/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "NBA on TNT",
          "tags": [
            "NBA on TNT",
            "NBA",
            "Inside the NBA",
            "Charles Barkley",
            "Shaq",
            "Kenny Smith",
            "Ernie Johnson"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Do NBA Superstars Get Preferential Treatment? | NBA on TNT",
            "description": "After the Lakers-Clippers game, Shaq, Chuck and Kenny debate if NBA stars get preferential treatment and the side effects that can cause in a locker room. \n\nWatch highlights from Inside the NBA with Shaq, Charles Barkley, Kenny Smith and Ernie Johnson and more! Subscribe now to be updated on the latest videos: https://www.youtube.com/nbaontnt?sub_confirmation=1\r\n\r\nConnect with NBA on TNT:\r\nFollow NBA on TNT on Twitter: https://twitter.com/NBAonTNT\r\nLike NBA on TNT on Facebook: https://www.facebook.com/NBAONTNT/\r\nFollow NBA on TNT on Instagram: https://www.instagram.com/nbaontnt/?hl=en"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT8M34S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "137264",
          "likeCount": "3238",
          "dislikeCount": "70",
          "favoriteCount": "0",
          "commentCount": "624"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "NdQCCBTTlFpe5BrdxaeGdh2lXjM",
        "id": "6abApk-3lOM",
        "snippet": {
          "publishedAt": "2020-12-21T21:01:42Z",
          "channelId": "UC3EFKdXAU99j3ppGgvTz7XQ",
          "title": "Filipino Food *GALORE* Mukbang - Moms Foodtruck is here",
          "description": "Please give it a thumbs up and share this video! \n------------------------------------------------------------------------------\n- AFFILIATION/DISCOUNT CODES -\n\nMorphe - 10% off entire purchase\nhttps://www.morphebrushes.com\nCode: BretmanRock\n\nOfra Cosmetics\nCode: BretmanRock\nOfracosmetics.com \n\nNubounsom Lashes - 20% entire purchase\nhttps://www.nubounsom.com\nCode: Bretman \n\nLilly Lashes - 10% off entire Purchase\nhttps://www.lillylashes.com\nCode: Bretman\n\nWhite With Style - $28 for any whitening kits\nhttps://www.whitewithstyle.com\n\nLAGirlUsa.com\nCode: BretmanRock10 for 10% off\n_____________________\n\n- KEEP IN TOUCH - \n\nWebsite | BretmanRock.com\nInstagram | @Bretmanrock - http://instagram.com/bretmanrock/\nTwitter | @BretmanRock - https://twitter.com/bretmanrock\nSnapchat | @BretmanRock\nTumblr | bretmanrock.tumblr.com\nFacebook | The Bretman Rock\nTikTok | @bretmanrock\n\nEmail/Business | management@dabaddest.com",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/6abApk-3lOM/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/6abApk-3lOM/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/6abApk-3lOM/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/6abApk-3lOM/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/6abApk-3lOM/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Bretman Rock",
          "tags": [
            "bretman",
            "bretman rock",
            "funny",
            "video",
            "dabaddest"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Filipino Food *GALORE* Mukbang - Moms Foodtruck is here",
            "description": "Please give it a thumbs up and share this video! \n------------------------------------------------------------------------------\n- AFFILIATION/DISCOUNT CODES -\n\nMorphe - 10% off entire purchase\nhttps://www.morphebrushes.com\nCode: BretmanRock\n\nOfra Cosmetics\nCode: BretmanRock\nOfracosmetics.com \n\nNubounsom Lashes - 20% entire purchase\nhttps://www.nubounsom.com\nCode: Bretman \n\nLilly Lashes - 10% off entire Purchase\nhttps://www.lillylashes.com\nCode: Bretman\n\nWhite With Style - $28 for any whitening kits\nhttps://www.whitewithstyle.com\n\nLAGirlUsa.com\nCode: BretmanRock10 for 10% off\n_____________________\n\n- KEEP IN TOUCH - \n\nWebsite | BretmanRock.com\nInstagram | @Bretmanrock - http://instagram.com/bretmanrock/\nTwitter | @BretmanRock - https://twitter.com/bretmanrock\nSnapchat | @BretmanRock\nTumblr | bretmanrock.tumblr.com\nFacebook | The Bretman Rock\nTikTok | @bretmanrock\n\nEmail/Business | management@dabaddest.com"
          }
        },
        "contentDetails": {
          "duration": "PT16M39S",
          "dimension": "2d",
          "definition": "sd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2025197",
          "likeCount": "174173",
          "dislikeCount": "1260",
          "favoriteCount": "0",
          "commentCount": "8629"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "X7wPcYKQdh8cDrZGhcOjr4Be7QA",
        "id": "1hx_LdKeexk",
        "snippet": {
          "publishedAt": "2020-12-21T23:01:13Z",
          "channelId": "UCmo9ZEJ3ipgaZdkiRRYtLAg",
          "title": "Reindeer Christmas Prank (Behind The Scenes)",
          "description": "December 2020 was FULL of Overtime! With a brand new episode every Monday!! Everything you love about Dude Perfect.. plus even more!  Be sure to SUBSCRIBE for more behind the scenes, bloopers, and bonus content! ► CLICK HERE: http://bit.ly/DPplusSubscribe\n\n► Click HERE to watch the main video: https://youtu.be/LP02BulYw3g\n\n► Click HERE to watch more Behind the Scenes on Dude Perfect Plus: https://www.youtube.com/watch?v=XBh4bnd51c4&list=PLC_fTveW0jTZ-jc2LqY4dvhpyYSuPgNB7&ab_channel=DudePerfectPlus\n\nNEXT LEVEL STUFF \n-------------------------------------------\n🎒 NEW Merch - bit.ly/DPStore\n🎮 Play our FREE iPhone game! - http://smarturl.it/DudePerfect2\n📱 Text us - (469) 205-7005\n🔔 Hit the bell next to Subscribe so you don't miss a video!\n👨🏻\u200d💻 Watch our newest vids! - http://bit.ly/NewDPVids\n📕 Read our Book - \"Go Big\" - http://amzn.to/OYdZ2s\n\nFollow our Instagrams so we can be best friends \n-------------------------------------------\n🏆 http://Instagram.com/DudePerfect\n🧔🏻 http://Instagram.com/TylerNToney\n👱🏻\u200d♂️ http://Instagram.com/Cody_Jones_\n🙋🏻\u200d♂️ http://Instagram.com/CobyCotton\n👨\u200d🦰 http://Instagram.com/GarrettHilbert\n⛹🏻\u200d♂️ http://Instagram.com/CoryCotton\n-------------------------------------------\nBonus points if you're still reading this! \nComment: Codes got hosed!\n\nClick here to learn more about Dude Perfect:\nhttp://bit.ly/AboutDudePerfect\n\nAs always...Go Big and God Bless!\n- Your friends at Dude Perfect\n\nBusiness or Media, please contact us at: \nDude@DudePerfect.com\n------------\n\n5 Best Friends and a Panda.\nIf you like Sports + Comedy, come join the Dude Perfect team!\n\nBest known for trick shots, stereotypes, battles, bottle flips, ping pong shots and all-around competitive fun, Dude Perfect prides ourselves in making the absolute best family-friendly entertainment possible! Welcome to the crew! \n\nPound it 👊🏻 Noggin 🙇🏻\u200d♂️ \n- Dude Perfect",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/1hx_LdKeexk/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/1hx_LdKeexk/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/1hx_LdKeexk/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/1hx_LdKeexk/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/1hx_LdKeexk/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Dude Perfect Plus",
          "tags": [
            "dude",
            "perfect",
            "plus",
            "bonus",
            "bts",
            "behind",
            "the",
            "scenes",
            "extra",
            "compilation",
            "dp",
            "editors",
            "funny",
            "bloopers",
            "deleted",
            "family",
            "team",
            "trick",
            "shot",
            "shots",
            "battle",
            "stereotype",
            "overtime",
            "sparky",
            "tyler",
            "cory",
            "coby",
            "cody",
            "garrett",
            "panda",
            "chad",
            "tim",
            "derek",
            "hashtag",
            "prank",
            "Christmas",
            "snow",
            "santa",
            "reindeer",
            "elf"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Reindeer Christmas Prank (Behind The Scenes)",
            "description": "December 2020 was FULL of Overtime! With a brand new episode every Monday!! Everything you love about Dude Perfect.. plus even more!  Be sure to SUBSCRIBE for more behind the scenes, bloopers, and bonus content! ► CLICK HERE: http://bit.ly/DPplusSubscribe\n\n► Click HERE to watch the main video: https://youtu.be/LP02BulYw3g\n\n► Click HERE to watch more Behind the Scenes on Dude Perfect Plus: https://www.youtube.com/watch?v=XBh4bnd51c4&list=PLC_fTveW0jTZ-jc2LqY4dvhpyYSuPgNB7&ab_channel=DudePerfectPlus\n\nNEXT LEVEL STUFF \n-------------------------------------------\n🎒 NEW Merch - bit.ly/DPStore\n🎮 Play our FREE iPhone game! - http://smarturl.it/DudePerfect2\n📱 Text us - (469) 205-7005\n🔔 Hit the bell next to Subscribe so you don't miss a video!\n👨🏻\u200d💻 Watch our newest vids! - http://bit.ly/NewDPVids\n📕 Read our Book - \"Go Big\" - http://amzn.to/OYdZ2s\n\nFollow our Instagrams so we can be best friends \n-------------------------------------------\n🏆 http://Instagram.com/DudePerfect\n🧔🏻 http://Instagram.com/TylerNToney\n👱🏻\u200d♂️ http://Instagram.com/Cody_Jones_\n🙋🏻\u200d♂️ http://Instagram.com/CobyCotton\n👨\u200d🦰 http://Instagram.com/GarrettHilbert\n⛹🏻\u200d♂️ http://Instagram.com/CoryCotton\n-------------------------------------------\nBonus points if you're still reading this! \nComment: Codes got hosed!\n\nClick here to learn more about Dude Perfect:\nhttp://bit.ly/AboutDudePerfect\n\nAs always...Go Big and God Bless!\n- Your friends at Dude Perfect\n\nBusiness or Media, please contact us at: \nDude@DudePerfect.com\n------------\n\n5 Best Friends and a Panda.\nIf you like Sports + Comedy, come join the Dude Perfect team!\n\nBest known for trick shots, stereotypes, battles, bottle flips, ping pong shots and all-around competitive fun, Dude Perfect prides ourselves in making the absolute best family-friendly entertainment possible! Welcome to the crew! \n\nPound it 👊🏻 Noggin 🙇🏻\u200d♂️ \n- Dude Perfect"
          }
        },
        "contentDetails": {
          "duration": "PT9M7S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1020292",
          "likeCount": "38150",
          "dislikeCount": "465",
          "favoriteCount": "0",
          "commentCount": "1254"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "av6NWhx8yaBMpKpFGdFgSW_etkU",
        "id": "4SjOv_szzVM",
        "snippet": {
          "publishedAt": "2020-12-22T18:00:01Z",
          "channelId": "UCJ0-OtVpF0wOKEqT2Z1HEtA",
          "title": "What It Takes to Break a RAM with ESD (ft. Linus Tech Tips)",
          "description": "Go to https://expressvpn.com/electroboom and find out how you can get 3 months of ExpressVPN free!\nWatch my Colab with Linus: https://youtu.be/nXkgbmr3dRA\nWe handle computer parts without ESD protection most of the times. But what does it take to break one with ESD through human body? Let’s check it out!\n\nSupport ElectroBOOM: http://patreon.com/electroboom\nCheckout my merch: http://teespring.com/stores/electroboom\nCheckout my Amazon picks (my affiliate link): https://www.amazon.com/shop/Electroboom\n\nPost your submissions to: http://reddit.com/r/electroboom \n\nMy Facebook: http://www.facebook.com/ElectroBOOM\nMy Twitter: http://twitter.com/electroboomguy\nMy other articles: https://www.electroboom.com/\n\nThanks to http://CircuitSpecialists.com and http://keysight.com for proving my essential lab tools and giveaways.\n\nBelow are my Super Patrons with support to the extreme!\n\nNicholas Moller at https://www.usbmemorydirect.com\nSam Lutfi\nEIM Technology: https://www.eimtechnology.com/\nMaestri Investment Group Ltd.: https://investmaestri.com/\n\nEnter your school for tools: https://goo.gl/forms/VAgRre8rLVvA1cEi2\n\nMy sponsors and top patrons: http://www.electroboom.com/?page_id=727\n\nBy: Mehdi Sadaghdar\n--------------------------------------------------------------------------",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/4SjOv_szzVM/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/4SjOv_szzVM/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/4SjOv_szzVM/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/4SjOv_szzVM/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/4SjOv_szzVM/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "ElectroBOOM",
          "tags": [
            "educational",
            "electrical",
            "ElectroBOOM",
            "science",
            "electronics",
            "engineering",
            "entertainment",
            "equipment",
            "measurement",
            "experiment",
            "mehdi",
            "mehdi sadaghdar",
            "arc",
            "mishap",
            "physics",
            "Sadaghdar",
            "test",
            "tools",
            "circuit",
            "funny",
            "learn",
            "shock",
            "spark",
            "discharge",
            "high voltage",
            "electrostatic discharge",
            "esd",
            "RAM",
            "computer parts",
            "esd protection",
            "handling",
            "grounding"
          ],
          "categoryId": "28",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en",
          "localized": {
            "title": "What It Takes to Break a RAM with ESD (ft. Linus Tech Tips)",
            "description": "Go to https://expressvpn.com/electroboom and find out how you can get 3 months of ExpressVPN free!\nWatch my Colab with Linus: https://youtu.be/nXkgbmr3dRA\nWe handle computer parts without ESD protection most of the times. But what does it take to break one with ESD through human body? Let’s check it out!\n\nSupport ElectroBOOM: http://patreon.com/electroboom\nCheckout my merch: http://teespring.com/stores/electroboom\nCheckout my Amazon picks (my affiliate link): https://www.amazon.com/shop/Electroboom\n\nPost your submissions to: http://reddit.com/r/electroboom \n\nMy Facebook: http://www.facebook.com/ElectroBOOM\nMy Twitter: http://twitter.com/electroboomguy\nMy other articles: https://www.electroboom.com/\n\nThanks to http://CircuitSpecialists.com and http://keysight.com for proving my essential lab tools and giveaways.\n\nBelow are my Super Patrons with support to the extreme!\n\nNicholas Moller at https://www.usbmemorydirect.com\nSam Lutfi\nEIM Technology: https://www.eimtechnology.com/\nMaestri Investment Group Ltd.: https://investmaestri.com/\n\nEnter your school for tools: https://goo.gl/forms/VAgRre8rLVvA1cEi2\n\nMy sponsors and top patrons: http://www.electroboom.com/?page_id=727\n\nBy: Mehdi Sadaghdar\n--------------------------------------------------------------------------"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT18M49S",
          "dimension": "2d",
          "definition": "sd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "650780",
          "likeCount": "73457",
          "dislikeCount": "736",
          "favoriteCount": "0",
          "commentCount": "3797"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "4D2VtIKw0_eCbHY1iTt3yZkuOc0",
        "id": "fmAtBZSTBYA",
        "snippet": {
          "publishedAt": "2020-12-22T02:10:50Z",
          "channelId": "UCyA2du_flsYZHLaoU_5Qjkg",
          "title": "House Tour Part 1 | Dhar and Laura",
          "description": "We hope you loved our House Tour Part 1! Part Two is coming real soon. To WIN an iPhone 12, all you have to do is SUBSCRIBE + COMMENT your Instagram or Twitter handle so we can message you if you won!\n\nALSO, BIG THANK YOU to Chad Mellon Studio who shot and edited this video, check them out on Instagram here: https://www.instagram.com/chadmellon/?hl=en\n\n💥 Don't forget to SUBSCRIBE to our channel by clicking here ➞ ➞ http://bit.ly/DharAndLauraYouTube **Make sure you click the bell icon so you can get notifications when our next video goes up so you don’t miss anything!\n\nCONNECT ON SOCIAL MEDIA: Follow official Dhar Mann and Laura G (LauraG_143) accounts below:\n\nLaura's Profiles:\nInstagram ➜ https://www.instagram.com/laurag_143 AND https://www.instagram.com/sweetlifeoflaura/\nTikTok ➜ https://www.tiktok.com/@laurag_143\nPinterest ➜ https://www.pinterest.com/LauraG_143O...\n\nDhar's Profiles:\nFacebook ➜ https://www.facebook.com/dharmannoffi...\nYouTube ➜ http://bit.ly/DharMannYouTube\nInstagram ➜ https://www.instagram.com/dhar.mann/\nTEXT Dhar (213-212-4550) ➜ http://bit.ly/DharMannCommunity\nTikTok ➜ https://www.tiktok.com/@dhar.mann\nShop Merch ➜ https://shop.dharmann.com/\n\nStay up to date with Ella Rose here: https://bit.ly/2YFfvDl",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/fmAtBZSTBYA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/fmAtBZSTBYA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/fmAtBZSTBYA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/fmAtBZSTBYA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/fmAtBZSTBYA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Dhar and Laura",
          "tags": [
            "dhar mann",
            "dhar and laura",
            "dhar mann and laura g",
            "laura g",
            "dhar manns house",
            "dhar and lauras house",
            "house tour",
            "dhar and laura house tour",
            "vlog",
            "couples vlog",
            "ella rose",
            "ella rose mann",
            "dhar mann house tour"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "House Tour Part 1 | Dhar and Laura",
            "description": "We hope you loved our House Tour Part 1! Part Two is coming real soon. To WIN an iPhone 12, all you have to do is SUBSCRIBE + COMMENT your Instagram or Twitter handle so we can message you if you won!\n\nALSO, BIG THANK YOU to Chad Mellon Studio who shot and edited this video, check them out on Instagram here: https://www.instagram.com/chadmellon/?hl=en\n\n💥 Don't forget to SUBSCRIBE to our channel by clicking here ➞ ➞ http://bit.ly/DharAndLauraYouTube **Make sure you click the bell icon so you can get notifications when our next video goes up so you don’t miss anything!\n\nCONNECT ON SOCIAL MEDIA: Follow official Dhar Mann and Laura G (LauraG_143) accounts below:\n\nLaura's Profiles:\nInstagram ➜ https://www.instagram.com/laurag_143 AND https://www.instagram.com/sweetlifeoflaura/\nTikTok ➜ https://www.tiktok.com/@laurag_143\nPinterest ➜ https://www.pinterest.com/LauraG_143O...\n\nDhar's Profiles:\nFacebook ➜ https://www.facebook.com/dharmannoffi...\nYouTube ➜ http://bit.ly/DharMannYouTube\nInstagram ➜ https://www.instagram.com/dhar.mann/\nTEXT Dhar (213-212-4550) ➜ http://bit.ly/DharMannCommunity\nTikTok ➜ https://www.tiktok.com/@dhar.mann\nShop Merch ➜ https://shop.dharmann.com/\n\nStay up to date with Ella Rose here: https://bit.ly/2YFfvDl"
          }
        },
        "contentDetails": {
          "duration": "PT21M2S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "708536",
          "likeCount": "37425",
          "dislikeCount": "1105",
          "favoriteCount": "0",
          "commentCount": "26897"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "CnHfuNSQD_0WU2mQvDvefW3SI18",
        "id": "c7HEM58-SC4",
        "snippet": {
          "publishedAt": "2020-12-22T18:00:13Z",
          "channelId": "UCYJPby9DRCteedh5tfxVbrw",
          "title": "Try Not to Laugh Challenge #60 - Gauntlet w/ Our Crew!",
          "description": "Today we’re back in the Gauntlet hot seats and our CREW is up for the Try Not To Laugh challenge!\n\nThis video was shot with a very limited crew. All cast & crew followed all CDC and California COVID-19 precautions and filming guidelines.\n\nWatch last year’s Gauntlet with our crew: https://youtu.be/V2P96OFekCE\n\nPunch that bell icon so you'll know when we add a new episode!\n\nSHOP THE SMOSH CLOTHING LINE: https://smosh.store\n\nCAST\nTommy Bowe: https://www.instagram.com/tomeybones\nRachel Evans: https://www.instagram.com/rachelsamevans\nSpencer Agnew: https://www.instagram.com/spennser/\nYasmeen Mughal: https://www.instagram.com/themughalempire/\nMatt Duran: https://www.instagram.com/durrrrran/\nGarrett Palm: https://www.instagram.com/gpalm79/\nKevin Rygg: https://www.instagram.com/kevin_rygg\nLayne Pavoggi: https://twitter.com/laynepavoggi\nMatt Raub: https://www.instagram.com/mattraub/\nSarah Whittle: https://www.instagram.com/rudeunicorns/\nLisa Van Lenner https://www.instagram.com/herestheproblem/\nIan Hecox: https://www.instagram.com/ianhecox/\nCourtney Miller: https://www.instagram.com/co_mill/\nShayne Topp: https://www.instagram.com/shaynetopp/\nDamien Haas: https://www.instagram.com/damienhaas/\nKeith Leak: https://www.instagram.com/keithleakjr/\nJacklyn Uweh: https://www.instagram.com/jacklyn_uweh/\nKimmy Jimenez: https://www.instagram.com/kimmydoesstuff/\n\nCREW\nVice President, Unscripted: Matt Raub\nExecutive Producer/Director: Sarah Whittle\nEditor: Rock Coleman\nProducer/Cam Op: Kevin Rygg\nProduction Manager: Garrett Palm\nProduction Coordinator: Nancy Azcona\nArt Director: Cassie Vance\nArt Coordinator: Yasmeen Mughal\nArt Assistant: Alex Aguilar\nDP: Brennan Iketani\nCam Op / G&E: Dustin Bloodgood\nSound Mixer: Greg Jones\nAssistant Editor/DIT: Matt Duran\nPA: Jacqi Jones\nPA: Andrew Harmon\nGFX: Brittany Metz \nContent Manager: Kiana Parker\nStage Manager: David Hill\nExecutive Assistant: Sammie Miller\n\nWatch BTS Stans: The World's Most Powerful Army: https://youtu.be/icULJn8sk1U\nWatch Try Not To Loud Challenge!: https://youtu.be/EiGipxBqhuY\nWatch The Dumbest Way to Die is… (Board AF): https://youtu.be/RuHugUy2g8A\nWatch Uno Battle in Smosh Vegas!: https://youtu.be/9jwCO8Hacbk\n\nSubscribe To Smosh Pit: https://smo.sh/Sub2SmoshPit\n\nFollow Us:\nInstagram: https://instagram.com/smosh\nTikTok: https://smo.sh/TikTok\nTwitch: https://twitch.tv/smoshgames\nFacebook: https://facebook.com/smosh\nTwitter: https://twitter.com/smosh\n\nCheck Out Our Other Smosh Channels:\nSmosh: https://smo.sh/Sub2Smosh\nSmosh Games: https://smo.sh/Sub2SmoshGames\nSmoshCast: https://smo.sh/Sub2SmoshCast",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/c7HEM58-SC4/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/c7HEM58-SC4/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/c7HEM58-SC4/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/c7HEM58-SC4/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/c7HEM58-SC4/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Smosh Pit",
          "tags": [
            "smosh",
            "smosh pit",
            "smosh games",
            "funny",
            "comedy",
            "Try Not to Laugh Challenge #60 - Gauntlet w/ Our Crew!",
            "christmas",
            "try not to laugh",
            "try not to laugh challenge",
            "tntl",
            "crew",
            "employees",
            "team",
            "improv",
            "smosh crew"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Try Not to Laugh Challenge #60 - Gauntlet w/ Our Crew!",
            "description": "Today we’re back in the Gauntlet hot seats and our CREW is up for the Try Not To Laugh challenge!\n\nThis video was shot with a very limited crew. All cast & crew followed all CDC and California COVID-19 precautions and filming guidelines.\n\nWatch last year’s Gauntlet with our crew: https://youtu.be/V2P96OFekCE\n\nPunch that bell icon so you'll know when we add a new episode!\n\nSHOP THE SMOSH CLOTHING LINE: https://smosh.store\n\nCAST\nTommy Bowe: https://www.instagram.com/tomeybones\nRachel Evans: https://www.instagram.com/rachelsamevans\nSpencer Agnew: https://www.instagram.com/spennser/\nYasmeen Mughal: https://www.instagram.com/themughalempire/\nMatt Duran: https://www.instagram.com/durrrrran/\nGarrett Palm: https://www.instagram.com/gpalm79/\nKevin Rygg: https://www.instagram.com/kevin_rygg\nLayne Pavoggi: https://twitter.com/laynepavoggi\nMatt Raub: https://www.instagram.com/mattraub/\nSarah Whittle: https://www.instagram.com/rudeunicorns/\nLisa Van Lenner https://www.instagram.com/herestheproblem/\nIan Hecox: https://www.instagram.com/ianhecox/\nCourtney Miller: https://www.instagram.com/co_mill/\nShayne Topp: https://www.instagram.com/shaynetopp/\nDamien Haas: https://www.instagram.com/damienhaas/\nKeith Leak: https://www.instagram.com/keithleakjr/\nJacklyn Uweh: https://www.instagram.com/jacklyn_uweh/\nKimmy Jimenez: https://www.instagram.com/kimmydoesstuff/\n\nCREW\nVice President, Unscripted: Matt Raub\nExecutive Producer/Director: Sarah Whittle\nEditor: Rock Coleman\nProducer/Cam Op: Kevin Rygg\nProduction Manager: Garrett Palm\nProduction Coordinator: Nancy Azcona\nArt Director: Cassie Vance\nArt Coordinator: Yasmeen Mughal\nArt Assistant: Alex Aguilar\nDP: Brennan Iketani\nCam Op / G&E: Dustin Bloodgood\nSound Mixer: Greg Jones\nAssistant Editor/DIT: Matt Duran\nPA: Jacqi Jones\nPA: Andrew Harmon\nGFX: Brittany Metz \nContent Manager: Kiana Parker\nStage Manager: David Hill\nExecutive Assistant: Sammie Miller\n\nWatch BTS Stans: The World's Most Powerful Army: https://youtu.be/icULJn8sk1U\nWatch Try Not To Loud Challenge!: https://youtu.be/EiGipxBqhuY\nWatch The Dumbest Way to Die is… (Board AF): https://youtu.be/RuHugUy2g8A\nWatch Uno Battle in Smosh Vegas!: https://youtu.be/9jwCO8Hacbk\n\nSubscribe To Smosh Pit: https://smo.sh/Sub2SmoshPit\n\nFollow Us:\nInstagram: https://instagram.com/smosh\nTikTok: https://smo.sh/TikTok\nTwitch: https://twitch.tv/smoshgames\nFacebook: https://facebook.com/smosh\nTwitter: https://twitter.com/smosh\n\nCheck Out Our Other Smosh Channels:\nSmosh: https://smo.sh/Sub2Smosh\nSmosh Games: https://smo.sh/Sub2SmoshGames\nSmoshCast: https://smo.sh/Sub2SmoshCast"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT17M31S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "555455",
          "likeCount": "44913",
          "dislikeCount": "428",
          "favoriteCount": "0",
          "commentCount": "2058"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "jWm1hdQ4sQcRiWT3DGFnf1JF-HA",
        "id": "ZebjXh_U4c0",
        "snippet": {
          "publishedAt": "2020-12-22T18:00:10Z",
          "channelId": "UCFlC8U0Uif2hF0FIgsSIIYQ",
          "title": "Grupo Firme - Me Gustas (Video Oficial)",
          "description": "Music Video by Grupo Firme performing - Me Gustas. © 2020 Isael Gutiérrez & Evert Gutiérrez , Exclusive License To Music VIP Entertainment Inc.\n\nDescárgalo Aquí: https://smarturl.it/NosDivertimosGF\nSuscríbete Aqui: https://bit.ly/333fXen\n\nDirector: Isael Gutiérrez & Evert Gutiérrez \nProductores: Isael Gutiérrez, Evert Gutiérrez & Eduin Caz\nDirección :Mane Borja\nTema: Me Gustas\nAutor: Eduin Caz & Uziel PayanDisquera: Music VIP Entertainment\n\nDisquera: Music VIP Entertainment Inc ℗ 2020\nGénero: Regional Mexicano \nEditora: Music VIP Entertainment Inc ℗ 2020\nIngeniero Audio: Orlando Sánchez\n\nProvided to YouTube by  Music VIP Entertainment Inc. ℗ 2020\nReleased on: 12-22-2020 Auto-generated by YouTube.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/ZebjXh_U4c0/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/ZebjXh_U4c0/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/ZebjXh_U4c0/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/ZebjXh_U4c0/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/ZebjXh_U4c0/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Grupo Firme",
          "tags": [
            "Grupo",
            "Firme",
            "me gustas",
            "video oficial",
            "official video",
            "music video",
            "video musicale",
            "Nos Divertimos Logrando Lo Imposible",
            "2020"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "defaultLanguage": "es-419",
          "localized": {
            "title": "Grupo Firme - Me Gustas (Video Oficial)",
            "description": "Music Video by Grupo Firme performing - Me Gustas. © 2020 Isael Gutiérrez & Evert Gutiérrez , Exclusive License To Music VIP Entertainment Inc.\n\nDescárgalo Aquí: https://smarturl.it/NosDivertimosGF\nSuscríbete Aqui: https://bit.ly/333fXen\n\nDirector: Isael Gutiérrez & Evert Gutiérrez \nProductores: Isael Gutiérrez, Evert Gutiérrez & Eduin Caz\nDirección :Mane Borja\nTema: Me Gustas\nAutor: Eduin Caz & Uziel PayanDisquera: Music VIP Entertainment\n\nDisquera: Music VIP Entertainment Inc ℗ 2020\nGénero: Regional Mexicano \nEditora: Music VIP Entertainment Inc ℗ 2020\nIngeniero Audio: Orlando Sánchez\n\nProvided to YouTube by  Music VIP Entertainment Inc. ℗ 2020\nReleased on: 12-22-2020 Auto-generated by YouTube."
          },
          "defaultAudioLanguage": "es-MX"
        },
        "contentDetails": {
          "duration": "PT3M31S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "776614",
          "likeCount": "61117",
          "dislikeCount": "736",
          "favoriteCount": "0",
          "commentCount": "1485"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "OS5xSYBH58v1vVyGbSQ815ydKzM",
        "id": "1HZAnkxdYuA",
        "snippet": {
          "publishedAt": "2020-12-22T14:00:00Z",
          "channelId": "UCjmJDM5pRKbUlVIzDYYWb6g",
          "title": "THE LITTLE THINGS – Official Trailer",
          "description": "Watch the trailer for The Little Things, bringing Denzel Washington back to screen alongside fellow Academy Award® winners Rami Malek and Jared Leto. Coming to theaters and streaming exclusively on HBO Max on January 29. #TheLittleThingsMovie\n\n\nAcademy Award winners Denzel Washington (“Training Day,” “Glory”), Rami Malek (“Bohemian Rhapsody”) and Jared Leto (“Dallas Buyers Club”) star in the psychological thriller “The Little Things.” John Lee Hancock (“The Blind Side,” “Saving Mr. Banks,” “The Founder”) directed the film from his own original screenplay.\n\nKern County Deputy Sheriff Joe “Deke” Deacon (Washington) is sent to Los Angeles for what should have been a quick evidence-gathering assignment. Instead, he becomes embroiled in the search for a killer who is terrorizing the city. Leading the hunt, L.A. Sheriff Department Sergeant Jim Baxter (Malek), impressed with Deke’s cop instincts, unofficially engages his help. But as they track the killer, Baxter is unaware that the investigation is dredging up echoes of Deke’s past, uncovering disturbing secrets that could threaten more than his case.\n\nThe main cast also includes Natalie Morales (“Battle of the Sexes”), Terry Kinney (“Mile 22,” TV’s “Billions”), Chris Bauer (“Sully,” TV’s “The Deuce”), Joris Jarsky (TV’s “Bad Blood”), Isabel Arraiza (TV’s “Pearson”) and Michael Hyatt (“Crazy Ex-Girlfriend”).\n\n“The Little Things” is produced by Oscar- and Emmy-winning producer Mark Johnson (“Breaking Bad,” “Rain Man”) and Hancock, with Mike Drake and Kevin McCormick serving as executive producers.\n\nBehind the scenes, Hancock reunited with several longtime collaborators, including Oscar-nominated director of photography John Schwartzman (“Seabiscuit,” “The Founder,” “Saving Mr. Banks”), Oscar-nominated production designer Michael Corenblith (“Apollo 13,” “The Founder,” “The Blind Side”) editor Robert Frazen (“The Founder”), and costume designer Daniel Orlandi (“The Founder,” “The Blind Side”). The music is by multiple Oscar-nominated composer Thomas Newman (“1917,” “Bridge of Spies,” “Saving Mr. Banks”).\n\nWarner Bros. Pictures presents A Gran Via Production, “The Little Things” will be distributed worldwide by Warner Bros. Pictures. The film has slated for release on January 29, 2021 in theaters and on HBO Max and has been rated R for violent/disturbing images, language and full nudity.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/1HZAnkxdYuA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/1HZAnkxdYuA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/1HZAnkxdYuA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/1HZAnkxdYuA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/1HZAnkxdYuA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Warner Bros. Pictures",
          "tags": [
            "The Little Things",
            "Detective",
            "Crime",
            "Criminal",
            "Sheriff",
            "Deputy",
            "Person of Interest",
            "FBI",
            "Los Angeles",
            "Kern County",
            "Fargo",
            "The Snowman",
            "Seven",
            "The Bone Collector",
            "Warner Brothers",
            "WB",
            "Warner Bros",
            "Warner Media",
            "Warner",
            "Film Warner",
            "Trailer",
            "Official Trailer",
            "Movie",
            "Film",
            "Film Trailer",
            "Coming Soon",
            "Crime Thriller",
            "Thriller",
            "Drama",
            "Jared Leto",
            "Rami Malek",
            "Denzel Washington",
            "John Lee Hancock"
          ],
          "categoryId": "1",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "THE LITTLE THINGS – Official Trailer",
            "description": "Watch the trailer for The Little Things, bringing Denzel Washington back to screen alongside fellow Academy Award® winners Rami Malek and Jared Leto. Coming to theaters and streaming exclusively on HBO Max on January 29. #TheLittleThingsMovie\n\n\nAcademy Award winners Denzel Washington (“Training Day,” “Glory”), Rami Malek (“Bohemian Rhapsody”) and Jared Leto (“Dallas Buyers Club”) star in the psychological thriller “The Little Things.” John Lee Hancock (“The Blind Side,” “Saving Mr. Banks,” “The Founder”) directed the film from his own original screenplay.\n\nKern County Deputy Sheriff Joe “Deke” Deacon (Washington) is sent to Los Angeles for what should have been a quick evidence-gathering assignment. Instead, he becomes embroiled in the search for a killer who is terrorizing the city. Leading the hunt, L.A. Sheriff Department Sergeant Jim Baxter (Malek), impressed with Deke’s cop instincts, unofficially engages his help. But as they track the killer, Baxter is unaware that the investigation is dredging up echoes of Deke’s past, uncovering disturbing secrets that could threaten more than his case.\n\nThe main cast also includes Natalie Morales (“Battle of the Sexes”), Terry Kinney (“Mile 22,” TV’s “Billions”), Chris Bauer (“Sully,” TV’s “The Deuce”), Joris Jarsky (TV’s “Bad Blood”), Isabel Arraiza (TV’s “Pearson”) and Michael Hyatt (“Crazy Ex-Girlfriend”).\n\n“The Little Things” is produced by Oscar- and Emmy-winning producer Mark Johnson (“Breaking Bad,” “Rain Man”) and Hancock, with Mike Drake and Kevin McCormick serving as executive producers.\n\nBehind the scenes, Hancock reunited with several longtime collaborators, including Oscar-nominated director of photography John Schwartzman (“Seabiscuit,” “The Founder,” “Saving Mr. Banks”), Oscar-nominated production designer Michael Corenblith (“Apollo 13,” “The Founder,” “The Blind Side”) editor Robert Frazen (“The Founder”), and costume designer Daniel Orlandi (“The Founder,” “The Blind Side”). The music is by multiple Oscar-nominated composer Thomas Newman (“1917,” “Bridge of Spies,” “Saving Mr. Banks”).\n\nWarner Bros. Pictures presents A Gran Via Production, “The Little Things” will be distributed worldwide by Warner Bros. Pictures. The film has slated for release on January 29, 2021 in theaters and on HBO Max and has been rated R for violent/disturbing images, language and full nudity."
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT2M25S",
          "dimension": "2d",
          "definition": "sd",
          "caption": "true",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "398432",
          "likeCount": "13221",
          "dislikeCount": "255",
          "favoriteCount": "0",
          "commentCount": "2038"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "krFpyERXQwKWHkzsi_EHqSkU_D0",
        "id": "RezB3Pn85yE",
        "snippet": {
          "publishedAt": "2020-12-21T23:30:13Z",
          "channelId": "UCyVppwD0G-t1KQM9zWn_oOA",
          "title": "morray - dreamland (official music video)",
          "description": "Download: https://picksix.ffm.to/dreamland IG: @morrayda1\nSubscribe to Morray https://tinyurl.com/yy8fzunh\n\nFollow Morray (@morrayda1)\nhttp://facebook.com/morrayda1\nhttp://soundcloud.com/morrayda1\nhttp://instagram.com/morrayda1\nhttp://twitter.com/morrayda1\n\nvideo by Christian Breslauer @christhedirector\n\nmorray dreamland",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/RezB3Pn85yE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/RezB3Pn85yE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/RezB3Pn85yE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/RezB3Pn85yE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/RezB3Pn85yE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Morray",
          "tags": [
            "Morray",
            "R&B",
            "Hip Hop",
            "Rap",
            "pick six records",
            "morray dreamland",
            "dreamland morray",
            "dreamland",
            "dream land",
            "moray quicksand",
            "quicksand morray",
            "morray switched up",
            "morray low key",
            "moray",
            "murray",
            "christmas",
            "birthday",
            "genius",
            "fayetteville",
            "North Carolina",
            "rod wave",
            "morae",
            "rmr",
            "roddy ricch",
            "dababy",
            "lyrical rap",
            "melodic rap",
            "pain",
            "quicksand",
            "black music",
            "nba youngboy",
            "future life is good",
            "morray quicksand",
            "rap music",
            "hip hop music",
            "music",
            "morrayda1"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "morray - dreamland (official music video)",
            "description": "Download: https://picksix.ffm.to/dreamland IG: @morrayda1\nSubscribe to Morray https://tinyurl.com/yy8fzunh\n\nFollow Morray (@morrayda1)\nhttp://facebook.com/morrayda1\nhttp://soundcloud.com/morrayda1\nhttp://instagram.com/morrayda1\nhttp://twitter.com/morrayda1\n\nvideo by Christian Breslauer @christhedirector\n\nmorray dreamland"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT2M42S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "429191",
          "likeCount": "34419",
          "dislikeCount": "371",
          "favoriteCount": "0",
          "commentCount": "3971"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "_3CjCU0-lqVsh4TOYIy_NCuqBvk",
        "id": "dg2Ag3e8W-Q",
        "snippet": {
          "publishedAt": "2020-12-19T22:00:03Z",
          "channelId": "UCX6OQ3DkcsbYNE6H8uQQuVA",
          "title": "I Opened A Restaurant That Pays You To Eat At It",
          "description": "Download our MrBeast Burger App and order food NOW!\nIOS - https://apps.apple.com/us/app/mrbeast-burger/id1543431762\nandroid - https://play.google.com/store/apps/details?id=com.chepri.mrbeastburger\nNew Merch - https://shopmrbeast.com/\n\nSUBSCRIBE OR I TAKE YOUR DOG\n╔═╦╗╔╦╗╔═╦═╦╦╦╦╗╔═╗\n║╚╣║║║╚╣╚╣╔╣╔╣║╚╣═╣ \n╠╗║╚╝║║╠╗║╚╣║║║║║═╣\n╚═╩══╩═╩═╩═╩╝╚╩═╩═╝\n\n----------------------------------------------------------------\nfollow all of these or i will kick you\n• Facebook - https://www.facebook.com/MrBeast6000/\n• Twitter - https://twitter.com/MrBeastYT\n•  Instagram - https://www.instagram.com/mrbeast\n--------------------------------------------------------------------",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/dg2Ag3e8W-Q/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/dg2Ag3e8W-Q/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/dg2Ag3e8W-Q/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/dg2Ag3e8W-Q/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/dg2Ag3e8W-Q/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "MrBeast",
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "I Opened A Restaurant That Pays You To Eat At It",
            "description": "Download our MrBeast Burger App and order food NOW!\nIOS - https://apps.apple.com/us/app/mrbeast-burger/id1543431762\nandroid - https://play.google.com/store/apps/details?id=com.chepri.mrbeastburger\nNew Merch - https://shopmrbeast.com/\n\nSUBSCRIBE OR I TAKE YOUR DOG\n╔═╦╗╔╦╗╔═╦═╦╦╦╦╗╔═╗\n║╚╣║║║╚╣╚╣╔╣╔╣║╚╣═╣ \n╠╗║╚╝║║╠╗║╚╣║║║║║═╣\n╚═╩══╩═╩═╩═╩╝╚╩═╩═╝\n\n----------------------------------------------------------------\nfollow all of these or i will kick you\n• Facebook - https://www.facebook.com/MrBeast6000/\n• Twitter - https://twitter.com/MrBeastYT\n•  Instagram - https://www.instagram.com/mrbeast\n--------------------------------------------------------------------"
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT10M39S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "26728163",
          "likeCount": "1924584",
          "dislikeCount": "17622",
          "favoriteCount": "0",
          "commentCount": "640616"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Tan3d6dRaoglz8lwARB0nMvoKPc",
        "id": "TN6E1gyb4qQ",
        "snippet": {
          "publishedAt": "2020-12-21T17:00:22Z",
          "channelId": "UCvAhDxNNUDhi78tMXVGBUaQ",
          "title": "We Bought Each Other The Most UNRELIABLE Luxury Cars EVER MADE - Car Trek S3 Episode 1",
          "description": "Watch how it all started with Car Trek Series 1! ► https://youtu.be/Dom6bmnd_Dc\nFind your DREAM car on AutoTempest!►http://bit.ly/CT3_1\nThanks to AutoTempest.com for sponsoring this series!\n--------------------------------------------------------------------\nOn today's episode of Car Trek, AutoTempest challenged us to find three of the world's cheapest and most unreliable luxury cars, to gift to each other. Unfortunately, Ed's reading comprehension skills took a vacation the day he got the text, so it may have been read slightly wrong...\n\n#CarTrek3 #FoundOnAutoTempest\n--------------------------------------------------------------------\nCOMPLETE CAR TREK SERIES 2 PLAYLIST:\nSeries 2, Episode 1 ►https://youtu.be/bDAiui-W79w\nSeries 2, Episode 2 ►https://youtu.be/ohRQjQ8AYh8\nSeries 2, Episode 3 ►https://youtu.be/otvA_QLAl70\nSeries 2, Episode 4 ►https://youtu.be/0Qt_ExrTx8E\nSeries 2, Episode 5(FINALE)►https://youtu.be/tqwd5VDEn88\n--------------------------------------------------------------------\nCOMPLETE CAR TREK SERIES 1 PLAYLIST:\nCar Trek Episode 1 ► https://youtu.be/Dom6bmnd_Dc\nCar Trek Episode 2 ►https://youtu.be/wPi1BJw-zsc\nCar Trek Episode 3 ►https://youtu.be/SJGWk9nX49U\nCar Trek Episode 4 ►https://youtu.be/9Woe-PnI9qg\nCar Trek Episode 5 ►https://youtu.be/Ug_GRlGQ0_A\nCar Trek Episode 6 ►https://youtu.be/7me9z2Xt90U\nCar Trek Episode 7 (FINALE)► https://youtu.be/LbpHcd1pa8I\n--------------------------------------------------------------------\nThe story of Tyler's Ferrari 360 Spider ►https://www.youtube.com/watch?v=IK0OKOPmFEM\nThe story of Ed's Lamborghini Gallardo►https://www.youtube.com/watch?v=2cjzI2M7eQc\n--------------------------------------------------------------------\nCar Trek on social media:\nInstagram ►https://www.instagram.com/cartrekofficial\n\nFreddy \"Tavarish\" Hernandez: \nInstagram ►https://www.instagram.com/therealtavarish\nYouTube► https://www.youtube.com/tavarish\n\nTyler Hoover:\nInstagram ►https://www.instagram.com/the_real_hoovies_garage\nYouTube ►https://www.youtube.com/channel/UCdEczn3MVkx_4PnMZ10MVFA\n\nEd Bolian: \nInstagram► https://www.instagram.com/vinwiki_official\nYouTube ►https://www.youtube.com/channel/UCefl-5pmhZmljwZTE2KrcdA\n--------------------------------------------------------------------\nBIG Thanks to our amazing production crew: \nThomas Durant►https://www.instagram.com/reheracte/\nJordan Cole► https://www.instagram.com/trustinthemachine/\nBrent Baxter► https://www.instagram.com/sidebproductions/\nVincent Monsaint►https://www.instagram.com/vmonsaint/\nJared Pink► https://www.instagram.com/jaredpink/\n--------------------------------------------------------------------\nSpecial thanks to Andrew Howell for the intro narration!\n►https://www.instagram.com/heavymetalfl\n--------------------------------------------------------------------\nQuestions? Comments? Business inquiries? Email me at asktavarish@gmail.com\n--------------------------------------------------------------------\nThanks to the companies that support this channel!\nAdvance Auto Parts - Enter 'TAVARISH2020\" at checkout to get up to 25% off!►https://bit.ly/AdvanceTav\nGet the Advance Auto Parts App►https://bit.ly/AdvanceAppTav\n\nValvoline - The Original Motor Oil►https://www.valvoline.com/\n\nFind your dream car on AutoTempest!►https://bit.ly/foundonautotempest\n--------------------------------------------------------------------\n--------------------------------------------------------------------",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/TN6E1gyb4qQ/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/TN6E1gyb4qQ/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/TN6E1gyb4qQ/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/TN6E1gyb4qQ/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/TN6E1gyb4qQ/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Tavarish",
          "tags": [
            "aston martin",
            "mercedes",
            "amg",
            "hyundai",
            "bmw",
            "lamborghini",
            "ferrari",
            "toyota",
            "supra",
            "mr2",
            "sw20",
            "3sgte",
            "2jz",
            "1jz",
            "sl55",
            "r230",
            "r231",
            "m113k",
            "vantage",
            "v8",
            "v12",
            "v10",
            "v6",
            "gallardo",
            "turbo",
            "cheap",
            "budget",
            "diy",
            "wrench everyday",
            "doug demuro",
            "chrisfix",
            "hoovies garage",
            "tavarish",
            "jalopnik",
            "mightycarmods",
            "motor trend",
            "roadkill",
            "hack",
            "bendpak",
            "tools",
            "lift",
            "4 post",
            "2 post",
            "quick jack",
            "welding",
            "how to",
            "tutorial"
          ],
          "categoryId": "2",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "We Bought Each Other The Most UNRELIABLE Luxury Cars EVER MADE - Car Trek S3 Episode 1",
            "description": "Watch how it all started with Car Trek Series 1! ► https://youtu.be/Dom6bmnd_Dc\nFind your DREAM car on AutoTempest!►http://bit.ly/CT3_1\nThanks to AutoTempest.com for sponsoring this series!\n--------------------------------------------------------------------\nOn today's episode of Car Trek, AutoTempest challenged us to find three of the world's cheapest and most unreliable luxury cars, to gift to each other. Unfortunately, Ed's reading comprehension skills took a vacation the day he got the text, so it may have been read slightly wrong...\n\n#CarTrek3 #FoundOnAutoTempest\n--------------------------------------------------------------------\nCOMPLETE CAR TREK SERIES 2 PLAYLIST:\nSeries 2, Episode 1 ►https://youtu.be/bDAiui-W79w\nSeries 2, Episode 2 ►https://youtu.be/ohRQjQ8AYh8\nSeries 2, Episode 3 ►https://youtu.be/otvA_QLAl70\nSeries 2, Episode 4 ►https://youtu.be/0Qt_ExrTx8E\nSeries 2, Episode 5(FINALE)►https://youtu.be/tqwd5VDEn88\n--------------------------------------------------------------------\nCOMPLETE CAR TREK SERIES 1 PLAYLIST:\nCar Trek Episode 1 ► https://youtu.be/Dom6bmnd_Dc\nCar Trek Episode 2 ►https://youtu.be/wPi1BJw-zsc\nCar Trek Episode 3 ►https://youtu.be/SJGWk9nX49U\nCar Trek Episode 4 ►https://youtu.be/9Woe-PnI9qg\nCar Trek Episode 5 ►https://youtu.be/Ug_GRlGQ0_A\nCar Trek Episode 6 ►https://youtu.be/7me9z2Xt90U\nCar Trek Episode 7 (FINALE)► https://youtu.be/LbpHcd1pa8I\n--------------------------------------------------------------------\nThe story of Tyler's Ferrari 360 Spider ►https://www.youtube.com/watch?v=IK0OKOPmFEM\nThe story of Ed's Lamborghini Gallardo►https://www.youtube.com/watch?v=2cjzI2M7eQc\n--------------------------------------------------------------------\nCar Trek on social media:\nInstagram ►https://www.instagram.com/cartrekofficial\n\nFreddy \"Tavarish\" Hernandez: \nInstagram ►https://www.instagram.com/therealtavarish\nYouTube► https://www.youtube.com/tavarish\n\nTyler Hoover:\nInstagram ►https://www.instagram.com/the_real_hoovies_garage\nYouTube ►https://www.youtube.com/channel/UCdEczn3MVkx_4PnMZ10MVFA\n\nEd Bolian: \nInstagram► https://www.instagram.com/vinwiki_official\nYouTube ►https://www.youtube.com/channel/UCefl-5pmhZmljwZTE2KrcdA\n--------------------------------------------------------------------\nBIG Thanks to our amazing production crew: \nThomas Durant►https://www.instagram.com/reheracte/\nJordan Cole► https://www.instagram.com/trustinthemachine/\nBrent Baxter► https://www.instagram.com/sidebproductions/\nVincent Monsaint►https://www.instagram.com/vmonsaint/\nJared Pink► https://www.instagram.com/jaredpink/\n--------------------------------------------------------------------\nSpecial thanks to Andrew Howell for the intro narration!\n►https://www.instagram.com/heavymetalfl\n--------------------------------------------------------------------\nQuestions? Comments? Business inquiries? Email me at asktavarish@gmail.com\n--------------------------------------------------------------------\nThanks to the companies that support this channel!\nAdvance Auto Parts - Enter 'TAVARISH2020\" at checkout to get up to 25% off!►https://bit.ly/AdvanceTav\nGet the Advance Auto Parts App►https://bit.ly/AdvanceAppTav\n\nValvoline - The Original Motor Oil►https://www.valvoline.com/\n\nFind your dream car on AutoTempest!►https://bit.ly/foundonautotempest\n--------------------------------------------------------------------\n--------------------------------------------------------------------"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT30M59S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1410389",
          "likeCount": "49408",
          "dislikeCount": "1460",
          "favoriteCount": "0",
          "commentCount": "3461"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "fu1J-3phCl6U4Ds1lObXPifi2UY",
        "id": "4VeMZFmWkEs",
        "snippet": {
          "publishedAt": "2020-12-20T17:27:46Z",
          "channelId": "UCHvpvPosasDgAbqGumlQqAw",
          "title": "VLOG #1: Q & A SNEAK PEAK",
          "description": "WATCH THE FULL VIDEO HERE https://anna-shumate.vhx.tv/\n\nVisit Anna Shumate's Official Website\nanna-shumate.com\n\nFollow Anna Shumate's Social Media Accounts\nhttps://www.instagram.com/annashumatee/\nhttps://www.tiktok.com/@annabananaxdddd?lang=en\nSnapchat: shumate.anna\nhttps://twitter.com/anna_shumate\n\nProduced and Filmed by\nthatguccigoose\nhttps://www.instagram.com/thatguccigoose/",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/4VeMZFmWkEs/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/4VeMZFmWkEs/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/4VeMZFmWkEs/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/4VeMZFmWkEs/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/4VeMZFmWkEs/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "ANNA SHUMATE",
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "VLOG #1: Q & A SNEAK PEAK",
            "description": "WATCH THE FULL VIDEO HERE https://anna-shumate.vhx.tv/\n\nVisit Anna Shumate's Official Website\nanna-shumate.com\n\nFollow Anna Shumate's Social Media Accounts\nhttps://www.instagram.com/annashumatee/\nhttps://www.tiktok.com/@annabananaxdddd?lang=en\nSnapchat: shumate.anna\nhttps://twitter.com/anna_shumate\n\nProduced and Filmed by\nthatguccigoose\nhttps://www.instagram.com/thatguccigoose/"
          }
        },
        "contentDetails": {
          "duration": "PT2M34S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "380720",
          "likeCount": "23338",
          "dislikeCount": "1469",
          "favoriteCount": "0",
          "commentCount": "1145"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "yN5vWYMXKz_X_WWiNeBIf9Mv9nE",
        "id": "rBYd_O38Ncw",
        "snippet": {
          "publishedAt": "2020-12-22T14:00:18Z",
          "channelId": "UCJHA_jMfCvEnv-3kRjTCQXw",
          "title": "Judy the Elf's Hot Cocoa from The Santa Clause | Binging with Babish",
          "description": "In a Klingon-like transfer of power ritual, the conveniently-initialed Scott Calvin kills Santa Clause in front of his son, puts on the dead man's clothes, and takes over his role as the bringer of joy to children around the world. Peyote-trip-storyline aside, there's some pretty choice hot cocoa served to the killer by one of his ancient child servants: a recipe perfected for 1200 years. Can we do the same in our home kitchen? Not without creating some potentially explosive, extra chocolatey hazards!\n\nRecipe: https://www.bingingwithbabish.com/recipes/judys-hot-cocoa-santa-clause\n\nMusic: \"Add And\" by Broke for Free\nhttps://soundcloud.com/broke-for-free\n\nJudy the Elf Hot Cocoa Mug (it's pewter, not sterling silver actually):\nhttps://bit.ly/3rokODs\n\nMy playlist of preferred cooking tunes, Bangers with Babish!\nhttps://spoti.fi/2TYXmiY\n\nBinging With Babish Website: http://bit.ly/BingingBabishWebsite\nBasics With Babish Website: http://bit.ly/BasicsWithBabishWebsite\nPatreon: http://bit.ly/BingingPatreon\nInstagram: http://bit.ly/BabishInstagram\nSubreddit: https://bit.ly/3mkNpp6\nFacebook: http://bit.ly/BabishFacebook\nTwitter: http://bit.ly/BabishTwitter",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/rBYd_O38Ncw/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/rBYd_O38Ncw/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/rBYd_O38Ncw/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/rBYd_O38Ncw/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/rBYd_O38Ncw/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Babish Culinary Universe",
          "tags": [
            "binging with babish",
            "babbish",
            "babish",
            "the santa clause",
            "santa clause",
            "santa claus",
            "the santa claus",
            "judy's hot chocolate recipe",
            "judy's hot cocoa recipe",
            "judy's hot cocoa",
            "judy's hot chocolate",
            "babish hot chocolate",
            "hot chocolate recipe",
            "hot chocolate",
            "hot cocoa",
            "hot cocoa recipe",
            "babish hot cocoa",
            "how to make hot cocoa",
            "basics with babish hot cocoa",
            "pear qwerty horse",
            "santa clause hot cocoa",
            "santa clause hot chocolate"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Judy the Elf's Hot Cocoa from The Santa Clause | Binging with Babish",
            "description": "In a Klingon-like transfer of power ritual, the conveniently-initialed Scott Calvin kills Santa Clause in front of his son, puts on the dead man's clothes, and takes over his role as the bringer of joy to children around the world. Peyote-trip-storyline aside, there's some pretty choice hot cocoa served to the killer by one of his ancient child servants: a recipe perfected for 1200 years. Can we do the same in our home kitchen? Not without creating some potentially explosive, extra chocolatey hazards!\n\nRecipe: https://www.bingingwithbabish.com/recipes/judys-hot-cocoa-santa-clause\n\nMusic: \"Add And\" by Broke for Free\nhttps://soundcloud.com/broke-for-free\n\nJudy the Elf Hot Cocoa Mug (it's pewter, not sterling silver actually):\nhttps://bit.ly/3rokODs\n\nMy playlist of preferred cooking tunes, Bangers with Babish!\nhttps://spoti.fi/2TYXmiY\n\nBinging With Babish Website: http://bit.ly/BingingBabishWebsite\nBasics With Babish Website: http://bit.ly/BasicsWithBabishWebsite\nPatreon: http://bit.ly/BingingPatreon\nInstagram: http://bit.ly/BabishInstagram\nSubreddit: https://bit.ly/3mkNpp6\nFacebook: http://bit.ly/BabishFacebook\nTwitter: http://bit.ly/BabishTwitter"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT5M39S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1224986",
          "likeCount": "73324",
          "dislikeCount": "436",
          "favoriteCount": "0",
          "commentCount": "2617"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "43jf62i9D8w26IhnAsmwhT6Rq5w",
        "id": "FTRjjC1NBJA",
        "snippet": {
          "publishedAt": "2020-12-22T04:43:53Z",
          "channelId": "UCJ5v_MCY6GNUBTO8-D3XoAg",
          "title": "Randy Orton ends up in Alexa’s Playground: Raw, Dec. 21, 2020",
          "description": "Randy Orton finds himself in the middle of a haunting edition of “A Moment of Bliss” as Alexa Bliss issues a chilling warning from her new playground. Catch WWE action on WWE Network, FOX, USA Network, Sony India and more.\nWWE Network | Subscribe now: http://wwe.yt/wwenetwork\r\n---------------------------------------------------------------------\r\nFollow WWE on YouTube for more exciting action!\r\n---------------------------------------------------------------------\r\nSubscribe to WWE on YouTube: http://wwe.yt/\r\nCheck out WWE.com for news and updates: http://goo.gl/akf0J4\r\nWatch WWE on Sony in India: http://www.wwe.com/SonySportsNetwork\r\nFind the latest Superstar gear at WWEShop: http://shop.wwe.com\r\n---------------------------------------------\r\nCheck out our other channels!\r\n---------------------------------------------\r\nThe Bella Twins: https://www.youtube.com/thebellatwins\r\nUpUpDownDown: https://www.youtube.com/upupdowndown\r\nWWEMusic: https://www.youtube.com/wwemusic\r\nTotal Divas: https://www.youtube.com/wwetotaldivas\r\n------------------------------------\r\nWWE on Social Media\r\n------------------------------------\r\nTwitter: https://twitter.com/wwe\r\nFacebook: https://www.facebook.com/wwe\r\nInstagram: https://www.instagram.com/wwe/\r\nReddit: https://www.reddit.com/user/RealWWE\r\nGiphy: https://giphy.com/wwe\r\n------------------------------------\r\nWWE Podcasts\r\n------------------------------------\r\nAfter the Bell with Corey Graves: https://wwe.com/afterthebell\r\nThe New Day: Feel the Power: https://wwe.com/feelthepower\r\nUncool with Alexa Bliss: https://wwe.com/uncoolwithalexa",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/FTRjjC1NBJA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/FTRjjC1NBJA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/FTRjjC1NBJA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/FTRjjC1NBJA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/FTRjjC1NBJA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "WWE",
          "tags": [
            "wwe",
            "world wrestling entertainment",
            "wrestling",
            "wrestler",
            "wrestle",
            "superstars",
            "कुश्ती",
            "पहलवान",
            "डब्लू डब्लू ई",
            "मैच",
            "सुपरस्टार",
            "व्यावसायिक कुश्ती",
            "مصارعه",
            "wwe 2020",
            "Raw",
            "Randy Orton",
            "Alexa Bliss",
            "raw highlights",
            "wwe raw highlights this week",
            "wwe monday night raw highlights",
            "alexa bliss firefly funhouse",
            "randy orton vs bray wyatt",
            "randy orton vs the fiend",
            "the fiend and alexa bliss",
            "wwe raw highlights",
            "the fiend bray wyatt",
            "wwe raw highlights today"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Randy Orton ends up in Alexa’s Playground: Raw, Dec. 21, 2020",
            "description": "Randy Orton finds himself in the middle of a haunting edition of “A Moment of Bliss” as Alexa Bliss issues a chilling warning from her new playground. Catch WWE action on WWE Network, FOX, USA Network, Sony India and more.\nWWE Network | Subscribe now: http://wwe.yt/wwenetwork\r\n---------------------------------------------------------------------\r\nFollow WWE on YouTube for more exciting action!\r\n---------------------------------------------------------------------\r\nSubscribe to WWE on YouTube: http://wwe.yt/\r\nCheck out WWE.com for news and updates: http://goo.gl/akf0J4\r\nWatch WWE on Sony in India: http://www.wwe.com/SonySportsNetwork\r\nFind the latest Superstar gear at WWEShop: http://shop.wwe.com\r\n---------------------------------------------\r\nCheck out our other channels!\r\n---------------------------------------------\r\nThe Bella Twins: https://www.youtube.com/thebellatwins\r\nUpUpDownDown: https://www.youtube.com/upupdowndown\r\nWWEMusic: https://www.youtube.com/wwemusic\r\nTotal Divas: https://www.youtube.com/wwetotaldivas\r\n------------------------------------\r\nWWE on Social Media\r\n------------------------------------\r\nTwitter: https://twitter.com/wwe\r\nFacebook: https://www.facebook.com/wwe\r\nInstagram: https://www.instagram.com/wwe/\r\nReddit: https://www.reddit.com/user/RealWWE\r\nGiphy: https://giphy.com/wwe\r\n------------------------------------\r\nWWE Podcasts\r\n------------------------------------\r\nAfter the Bell with Corey Graves: https://wwe.com/afterthebell\r\nThe New Day: Feel the Power: https://wwe.com/feelthepower\r\nUncool with Alexa Bliss: https://wwe.com/uncoolwithalexa"
          }
        },
        "contentDetails": {
          "duration": "PT3M10S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1386122",
          "likeCount": "37891",
          "dislikeCount": "1088",
          "favoriteCount": "0",
          "commentCount": "3113"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "RSRB38ICP03Uw9Y3XulPohiVML0",
        "id": "Mr5YmPWC9JQ",
        "snippet": {
          "publishedAt": "2020-12-21T18:00:47Z",
          "channelId": "UCkoZyNqTZyBZ8nu8E_OSkWw",
          "title": "SHOCKING ULTRASOUND... TWINS?! | LAUREN & ARIE",
          "description": "Many of you watched our journey through loss and our recent pregnancy announcement. We are so so grateful for all of the love and support from you guys! We feel so lucky. Follow along and subscribe to see this amazing part of our lives unfold.\n\nWatch our pregnancy announcement: https://youtu.be/2Up7Jbtg37A\n\nSubscribe to follow along on our pregnancy journey!\n\nFollow us on Instagram too!\nhttps://www.instagram.com/laurenluyendyk\nhttps://www.instagram.com/ariejr\nhttps://www.instagram.com/alessiluyendyk\n\nAs always, we love and appreciate every one of you!\n\n-Lauren and Arie Luyendyk",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/Mr5YmPWC9JQ/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/Mr5YmPWC9JQ/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/Mr5YmPWC9JQ/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/Mr5YmPWC9JQ/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/Mr5YmPWC9JQ/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Lauren & Arie",
          "tags": [
            "Lauren and Arie",
            "Arie and Lauren",
            "Lauren Burnham",
            "Lauren Luyendyk",
            "Arie Luyendyk",
            "Twins",
            "Twin pregnancy",
            "Natural Twins",
            "Fraternal twins",
            "Bachelor Twins",
            "The Bachelor"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "SHOCKING ULTRASOUND... TWINS?! | LAUREN & ARIE",
            "description": "Many of you watched our journey through loss and our recent pregnancy announcement. We are so so grateful for all of the love and support from you guys! We feel so lucky. Follow along and subscribe to see this amazing part of our lives unfold.\n\nWatch our pregnancy announcement: https://youtu.be/2Up7Jbtg37A\n\nSubscribe to follow along on our pregnancy journey!\n\nFollow us on Instagram too!\nhttps://www.instagram.com/laurenluyendyk\nhttps://www.instagram.com/ariejr\nhttps://www.instagram.com/alessiluyendyk\n\nAs always, we love and appreciate every one of you!\n\n-Lauren and Arie Luyendyk"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT14M7S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "663426",
          "likeCount": "15631",
          "dislikeCount": "225",
          "favoriteCount": "0",
          "commentCount": "1878"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "-DnTNKvl4o4H8zR552xunYVDda4",
        "id": "48dx4fL7Q4Q",
        "snippet": {
          "publishedAt": "2020-12-23T05:41:13Z",
          "channelId": "UCWJ2lWNubArHWmf3FIHbfcQ",
          "title": "CLIPPERS at LAKERS | FULL GAME HIGHLIGHTS | December 22, 2020",
          "description": "CLIPPERS at LAKERS | FULL GAME HIGHLIGHTS | December 22, 2020\n\nPaul George (33 PTS, 6 REB, 3 AST) and the LA Clippers cruised to a 116-109 win over the Los Angeles Lakers to earn their first win of the 2020-21 NBA season during #KiaTipOff20. Kawhi Leonard added 26 PTS, 3 AST and 2 STL in the winning effort, and Serge Ibaka recorded 15 PTS and 6 REB in his Clippers debut. LeBron James (22 PTS, 5 REB and 5 AST) led the way for the Lakers, while Dennis Schroder (14 PTS, 12 REB, 8 AST) and Montrezl Harrell (17 PTS, 10 REB) both recorded double-doubles in their Lakers debuts. Anthony Davis scored 18 PTS and 7 REB for Los Angeles.\n\nNext Games:\nDallas Mavericks at Los Angeles Lakers – Dec. 25 at 8pm/et on ABC/ESPN\nLA Clippers at Denver Nuggets – Dec. 25 at 10:30pm/et on ESPN\n\nSubscribe to the NBA: https://on.nba.com/2JX5gSN \r\n\nFull Game Highlights Playlist: https://on.nba.com/2rjGMge\r\n\nFor news, stories, highlights and more, go to our official website at https://nba_webonly.app.link/nbasite\r\n\nGet NBA LEAGUE PASS: https://nba.app.link/nbaleaguepass5",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/48dx4fL7Q4Q/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/48dx4fL7Q4Q/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/48dx4fL7Q4Q/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/48dx4fL7Q4Q/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/48dx4fL7Q4Q/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "NBA",
          "tags": [
            "NBA",
            "G League",
            "Basketball",
            "game-0022000002",
            "Clippers",
            "Lakers",
            "Pass",
            "Assist",
            "Dunk",
            "Jump Shot",
            "Steal",
            "Rebound",
            "Offense",
            "Defense",
            "Three",
            "Three-Pointer",
            "Triple",
            "Mid-Range",
            "Jumper",
            "Fadeaway",
            "Highlight",
            "Highlights",
            "Play",
            "Plays",
            "NBA Season",
            "2020-21 Season",
            "Full Game Highlights",
            "Full Game Recap"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "CLIPPERS at LAKERS | FULL GAME HIGHLIGHTS | December 22, 2020",
            "description": "CLIPPERS at LAKERS | FULL GAME HIGHLIGHTS | December 22, 2020\n\nPaul George (33 PTS, 6 REB, 3 AST) and the LA Clippers cruised to a 116-109 win over the Los Angeles Lakers to earn their first win of the 2020-21 NBA season during #KiaTipOff20. Kawhi Leonard added 26 PTS, 3 AST and 2 STL in the winning effort, and Serge Ibaka recorded 15 PTS and 6 REB in his Clippers debut. LeBron James (22 PTS, 5 REB and 5 AST) led the way for the Lakers, while Dennis Schroder (14 PTS, 12 REB, 8 AST) and Montrezl Harrell (17 PTS, 10 REB) both recorded double-doubles in their Lakers debuts. Anthony Davis scored 18 PTS and 7 REB for Los Angeles.\n\nNext Games:\nDallas Mavericks at Los Angeles Lakers – Dec. 25 at 8pm/et on ABC/ESPN\nLA Clippers at Denver Nuggets – Dec. 25 at 10:30pm/et on ESPN\n\nSubscribe to the NBA: https://on.nba.com/2JX5gSN \r\n\nFull Game Highlights Playlist: https://on.nba.com/2rjGMge\r\n\nFor news, stories, highlights and more, go to our official website at https://nba_webonly.app.link/nbasite\r\n\nGet NBA LEAGUE PASS: https://nba.app.link/nbaleaguepass5"
          }
        },
        "contentDetails": {
          "duration": "PT9M41S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "regionRestriction": {
            "allowed": [
              "PH",
              "IN",
              "US",
              "CA"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "1414325",
          "likeCount": "17666",
          "dislikeCount": "790",
          "favoriteCount": "0",
          "commentCount": "5750"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "dJ5Y1fixFGemdhTrRPLsrjjeisw",
        "id": "ApR8hLlu2pY",
        "snippet": {
          "publishedAt": "2020-12-22T22:45:22Z",
          "channelId": "UCfNWN9s_s8kRTCadk04WWJA",
          "title": "SIMON CHALLENGED ME TO DO THIS...",
          "description": "100 Shots Challenge\nJoin me on the road to Qatar 2022:\nhttp://instagram.com/roadto2022en\n\nSimon's video: https://www.youtube.com/watch?v=M5ogADxX_vQ\n\nINSTAGRAM: https://instagram.com/tobjizzle\nTWITTER: https://goo.gl/7p3nJr\nTWITCH: https://goo.gl/oz9LvZ\nFACEBOOK: https://goo.gl/ozBga6\n\nSECOND CHANNEL: ►►http://youtube.com/TBJZLPlays◄◄\nMy Recording Device: ►► https://goo.gl/oNcNkA◄◄\n\nWhere I got my custom PC: ►►https://goo.gl/QvasGx ◄◄\n \nSIDEMEN CLOTHING:►►https://goo.gl/R9Z7zd ◄◄\nSidemen Clothing Twitter: ►► https://goo.gl/2iwzxi ◄◄\n \nBuy my Gaming Chair: ►► https://goo.gl/pKnNmM◄◄\nGet 5% off with the code 'TBJZL'\n \n\nFeedback, as always, is appreciated ♥",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/ApR8hLlu2pY/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/ApR8hLlu2pY/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/ApR8hLlu2pY/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/ApR8hLlu2pY/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/ApR8hLlu2pY/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "TBJZL",
          "tags": [
            "TOBJIZZLE",
            "Tobi",
            "Jizzle",
            "Tobjizzle",
            "Tobijizzle",
            "tbjzl",
            "Toby",
            "editingaming",
            "xbox 360"
          ],
          "categoryId": "20",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "SIMON CHALLENGED ME TO DO THIS...",
            "description": "100 Shots Challenge\nJoin me on the road to Qatar 2022:\nhttp://instagram.com/roadto2022en\n\nSimon's video: https://www.youtube.com/watch?v=M5ogADxX_vQ\n\nINSTAGRAM: https://instagram.com/tobjizzle\nTWITTER: https://goo.gl/7p3nJr\nTWITCH: https://goo.gl/oz9LvZ\nFACEBOOK: https://goo.gl/ozBga6\n\nSECOND CHANNEL: ►►http://youtube.com/TBJZLPlays◄◄\nMy Recording Device: ►► https://goo.gl/oNcNkA◄◄\n\nWhere I got my custom PC: ►►https://goo.gl/QvasGx ◄◄\n \nSIDEMEN CLOTHING:►►https://goo.gl/R9Z7zd ◄◄\nSidemen Clothing Twitter: ►► https://goo.gl/2iwzxi ◄◄\n \nBuy my Gaming Chair: ►► https://goo.gl/pKnNmM◄◄\nGet 5% off with the code 'TBJZL'\n \n\nFeedback, as always, is appreciated ♥"
          },
          "defaultAudioLanguage": "en-GB"
        },
        "contentDetails": {
          "duration": "PT21M57S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "448258",
          "likeCount": "38698",
          "dislikeCount": "294",
          "favoriteCount": "0",
          "commentCount": "1612"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "gEcXgV2hJNY4aGRySvYxOAXHmaw",
        "id": "ZbkC_7wQKgA",
        "snippet": {
          "publishedAt": "2020-12-22T17:00:30Z",
          "channelId": "UCfDNi1aEljAQ17mUrfUjkvg",
          "title": "Alton Brown's Easy Peanut Butter Fudge",
          "description": "Few holiday treats say \"I care\" quite like fudge, which is delicious, tedious, and time consuming. Since it only has 4 ingredients and takes about 10 minutes to make, this fudge says \"I forgot to get you anything, so I made this at the last minute.\" Luckily, it's so delicious, no one will really care. \nHappy Holidays!\n\nGet the recipe: https://altonbrown.com/recipes/peanut-butter-fudge/\nGet some last-minute stocking stuffers: https://altonbrown.com/products/",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/ZbkC_7wQKgA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/ZbkC_7wQKgA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/ZbkC_7wQKgA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/ZbkC_7wQKgA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/ZbkC_7wQKgA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Alton Brown",
          "categoryId": "26",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en",
          "localized": {
            "title": "Alton Brown's Easy Peanut Butter Fudge",
            "description": "Few holiday treats say \"I care\" quite like fudge, which is delicious, tedious, and time consuming. Since it only has 4 ingredients and takes about 10 minutes to make, this fudge says \"I forgot to get you anything, so I made this at the last minute.\" Luckily, it's so delicious, no one will really care. \nHappy Holidays!\n\nGet the recipe: https://altonbrown.com/recipes/peanut-butter-fudge/\nGet some last-minute stocking stuffers: https://altonbrown.com/products/"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT8M5S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "140144",
          "likeCount": "8800",
          "dislikeCount": "49",
          "favoriteCount": "0",
          "commentCount": "683"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "P2Bivmd9fTKqzOYiKJKznSm0OF8",
        "id": "K0pkchEwMJA",
        "snippet": {
          "publishedAt": "2020-12-21T18:00:10Z",
          "channelId": "UC-PbLusIBd3ECYtvz-f0EcQ",
          "title": "King Von - Bless The Booth Freestyle",
          "description": "King Von, Chicago rapper, spits an exclusive freestyle for Audiomack's Bless The Booth freestyle series.\n\nLong Live King Von. \n\nShot & Edited by Sage English (@Sageenglish)\nBeat produced by TGUT (@tgut)\n\nAudiomack is a FREE, limitless music sharing and discovery platform for artists, tastemakers, labels, and fans. Download the app to discover millions of new artists, songs and sounds for free here: https: //audiomack.app.link/v2email\n\nSubscribe to Audiomack: https://amack.it/subscribe \nListen to the original audio on Audiomack: https://audiomack.com/king-von/song/bless-the-booth-freestyle\n\nWatch Trap Symphony: https://bit.ly/TrapSymphony \nWatch Fine Tuned: https://bit.ly/FineTunedYouTube \nWatch Prank Calls w/ Audiomack: https://bit.ly/PrankCallsAudioMack\n\nAudiomack on Instagram: https://amack.it/insta \nAudiomack on Twitter: https://amack.it/twitter \nAudiomack on Facebook: https://amack.it/facebook \nDownload the app: https://audiomack.app.link/v2email\n\n#Audiomack #KingVon #BlessTheBooth",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/K0pkchEwMJA/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/K0pkchEwMJA/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/K0pkchEwMJA/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/K0pkchEwMJA/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/K0pkchEwMJA/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "audiomack",
          "tags": [
            "audiomack",
            "audio mack",
            "trap symphony",
            "fine tuned",
            "prank calls",
            "audiomack ink",
            "interviews",
            "hip hop interviews",
            "audiomack app",
            "king von",
            "king von performance",
            "king von performing live",
            "king von freestyle",
            "freestyle",
            "chicago",
            "chicago rappers",
            "lil durk",
            "OTF",
            "new york",
            "audiomack trap symphony",
            "audiomack fine tuned",
            "bless the booth",
            "audiomack bless the booth",
            "bless the booth freestyle",
            "took her to the o",
            "the code king von",
            "crazy story king von",
            "demon king von"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "King Von - Bless The Booth Freestyle",
            "description": "King Von, Chicago rapper, spits an exclusive freestyle for Audiomack's Bless The Booth freestyle series.\n\nLong Live King Von. \n\nShot & Edited by Sage English (@Sageenglish)\nBeat produced by TGUT (@tgut)\n\nAudiomack is a FREE, limitless music sharing and discovery platform for artists, tastemakers, labels, and fans. Download the app to discover millions of new artists, songs and sounds for free here: https: //audiomack.app.link/v2email\n\nSubscribe to Audiomack: https://amack.it/subscribe \nListen to the original audio on Audiomack: https://audiomack.com/king-von/song/bless-the-booth-freestyle\n\nWatch Trap Symphony: https://bit.ly/TrapSymphony \nWatch Fine Tuned: https://bit.ly/FineTunedYouTube \nWatch Prank Calls w/ Audiomack: https://bit.ly/PrankCallsAudioMack\n\nAudiomack on Instagram: https://amack.it/insta \nAudiomack on Twitter: https://amack.it/twitter \nAudiomack on Facebook: https://amack.it/facebook \nDownload the app: https://audiomack.app.link/v2email\n\n#Audiomack #KingVon #BlessTheBooth"
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT1M11S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "324894",
          "likeCount": "21252",
          "dislikeCount": "184",
          "favoriteCount": "0",
          "commentCount": "1612"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Jqr3iaNoNj4B3B3ul3ckB8g2TzA",
        "id": "IKKbboquS9s",
        "snippet": {
          "publishedAt": "2020-12-21T14:00:10Z",
          "channelId": "UC-8Q-hLdECwQmaWNwXitYDw",
          "title": "Katy Perry - Not the End of the World",
          "description": "Katy Perry's new album \"Smile\" out now - http://katy.to/smileID\n\nListen to “Not The End Of The World” - http://katy.to/smileID\n\nKaty Perry Complete Collection on Spotify: http://katy.to/SpotifyCompleteYD\nKaty Perry Essentials on Apple Music: http://katy.to/AMEssentialsYD\nWatch your favorite Katy videos on YouTube: http://katy.to/MusicVideosYD\n\nFollow Katy Perry: Website: http://katy.to/WebsiteYD\nInstagram: http://katy.to/InstagramYD\nTwitter: http://katy.to/TwitterYD\nFacebook: http://katy.to/FacebookYD\nWeibo: http://katy.to/WeiboYD\nVK: http://katy.to/VKPageYD\n\n#katyperry #smile #nottheendoftheworld\n\nMusic video by Katy Perry performing Not the End of the World. © 2020 Capitol Records, LLC",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/IKKbboquS9s/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/IKKbboquS9s/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/IKKbboquS9s/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/IKKbboquS9s/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/IKKbboquS9s/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "KatyPerryVEVO",
          "tags": [
            "Katy",
            "Perry",
            "Not",
            "the",
            "End",
            "World",
            "Capitol",
            "Records",
            "Pop",
            "katy perry",
            "katy perry 2020",
            "new katy perry",
            "katy",
            "capitol records",
            "smile",
            "resilient",
            "katy perry cozy",
            "katie parry",
            "katie perry",
            "not the end of the world",
            "daisy",
            "daisies",
            "dark horse",
            "last friday night"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Katy Perry - Not the End of the World",
            "description": "Katy Perry's new album \"Smile\" out now - http://katy.to/smileID\n\nListen to “Not The End Of The World” - http://katy.to/smileID\n\nKaty Perry Complete Collection on Spotify: http://katy.to/SpotifyCompleteYD\nKaty Perry Essentials on Apple Music: http://katy.to/AMEssentialsYD\nWatch your favorite Katy videos on YouTube: http://katy.to/MusicVideosYD\n\nFollow Katy Perry: Website: http://katy.to/WebsiteYD\nInstagram: http://katy.to/InstagramYD\nTwitter: http://katy.to/TwitterYD\nFacebook: http://katy.to/FacebookYD\nWeibo: http://katy.to/WeiboYD\nVK: http://katy.to/VKPageYD\n\n#katyperry #smile #nottheendoftheworld\n\nMusic video by Katy Perry performing Not the End of the World. © 2020 Capitol Records, LLC"
          }
        },
        "contentDetails": {
          "duration": "PT3M54S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": true,
          "regionRestriction": {
            "allowed": [
              "SE",
              "SD",
              "SG",
              "KY",
              "SC",
              "KZ",
              "SM",
              "SL",
              "KW",
              "SN",
              "SI",
              "SH",
              "SK",
              "KR",
              "KM",
              "ST",
              "KN",
              "KI",
              "KH",
              "SR",
              "KE",
              "SA",
              "KG",
              "SY",
              "SX",
              "SZ",
              "HK",
              "HM",
              "HN",
              "TJ",
              "HR",
              "HT",
              "HU",
              "SO",
              "RE",
              "RO",
              "JP",
              "JO",
              "JM",
              "RS",
              "JE",
              "CU",
              "CW",
              "CV",
              "CR",
              "CY",
              "CX",
              "CZ",
              "CD",
              "CG",
              "SV",
              "CA",
              "CC",
              "CM",
              "CL",
              "CO",
              "CN",
              "CI",
              "CH",
              "CK",
              "FI",
              "QA",
              "ZA",
              "FJ",
              "FK",
              "YT",
              "FO",
              "FM",
              "YE",
              "CF",
              "FR",
              "PH",
              "PK",
              "PL",
              "PM",
              "PN",
              "SB",
              "PA",
              "PE",
              "PF",
              "PG",
              "PY",
              "TL",
              "VC",
              "PR",
              "PS",
              "PT",
              "PW",
              "IE",
              "ID",
              "AZ",
              "AX",
              "AW",
              "IN",
              "AU",
              "IL",
              "AS",
              "AR",
              "AQ",
              "VG",
              "AO",
              "AM",
              "AL",
              "IS",
              "IR",
              "AI",
              "AG",
              "AF",
              "AE",
              "AD",
              "IT",
              "IM",
              "UA",
              "AT",
              "OM",
              "DM",
              "DO",
              "DJ",
              "DK",
              "SJ",
              "DE",
              "WS",
              "DZ",
              "WF",
              "NR",
              "NP",
              "NU",
              "NZ",
              "TH",
              "NC",
              "NA",
              "NF",
              "NG",
              "NE",
              "NI",
              "NO",
              "NL",
              "GI",
              "GH",
              "BT",
              "GM",
              "GL",
              "RW",
              "GN",
              "GA",
              "GB",
              "GE",
              "GD",
              "GG",
              "VU",
              "GY",
              "VI",
              "VN",
              "GQ",
              "GP",
              "GS",
              "GR",
              "GU",
              "GT",
              "GW",
              "VE",
              "MZ",
              "MY",
              "MX",
              "UG",
              "ZW",
              "MS",
              "MR",
              "MQ",
              "MP",
              "MW",
              "MV",
              "UM",
              "MT",
              "MK",
              "MH",
              "MO",
              "MN",
              "MM",
              "ML",
              "MC",
              "UZ",
              "UY",
              "MG",
              "MF",
              "ME",
              "MD",
              "VA",
              "BW",
              "US",
              "BR",
              "BS",
              "BQ",
              "BZ",
              "BY",
              "BF",
              "BG",
              "BD",
              "BE",
              "BB",
              "ZM",
              "BA",
              "BN",
              "BO",
              "BL",
              "BM",
              "BJ",
              "BH",
              "BI",
              "LT",
              "LU",
              "LV",
              "BV",
              "IQ",
              "LR",
              "LS",
              "MU",
              "LY",
              "GF",
              "LA",
              "LB",
              "LC",
              "LI",
              "MA",
              "LK",
              "ES",
              "ER",
              "TG",
              "TZ",
              "ET",
              "TT",
              "TV",
              "TW",
              "TR",
              "EC",
              "TM",
              "TN",
              "TO",
              "EG",
              "EE",
              "TK",
              "TD",
              "TF",
              "EH",
              "RU",
              "TC"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "3924985",
          "likeCount": "292103",
          "dislikeCount": "9288",
          "favoriteCount": "0",
          "commentCount": "37533"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "ypv7QRpw1cyyST2P0Toe9VtzNcg",
        "id": "eSYBDVShBJI",
        "snippet": {
          "publishedAt": "2020-12-22T23:01:34Z",
          "channelId": "UCr19bNQQxC00MI6DLbpGQhg",
          "title": "ARSENAL 1-4 MAN CITY | TROOPZ FAN CAM | EDU SIGNED THESE FRAUDS, HE’S JUST AS BAD AS ARTETA!!",
          "description": "Subscribe To My Youtube: https://t.co/J7AXQuexvv\r\nADD ME ON:\r\nTwitter: https://twitter.com/Troopzafc\r\nInstagram: https://www.instagram.com/Troopzafc\r\nSnapchat: Troopz187",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/eSYBDVShBJI/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/eSYBDVShBJI/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/eSYBDVShBJI/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/eSYBDVShBJI/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/eSYBDVShBJI/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "TroopzTV",
          "tags": [
            "Arsenal F.C.",
            "Arsenal Fan TV",
            "Football",
            "troopz",
            "troopztv",
            "troopztv official",
            "troopz tv",
            "troopzafc",
            "troopz aftv",
            "troopz wife",
            "dad",
            "daddy",
            "boyfriend",
            "husband",
            "man",
            "woman",
            "mom",
            "momma",
            "mum",
            "mummy",
            "mommy",
            "girlfriend",
            "wife",
            "partner",
            "kids",
            "kid",
            "child",
            "children",
            "fun",
            "playing games",
            "gaming",
            "xbox one",
            "ps4",
            "nintendo switch",
            "fortnite travis scott",
            "fortnite",
            "fifa 20",
            "family",
            "family vlogs",
            "family vloggers",
            "family video",
            "vlog",
            "lockdown",
            "uk lockdown",
            "coronavirus",
            "shopping",
            "tesco",
            "sainsburys",
            "cooking",
            "lamb",
            "boris johnson",
            "london"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "ARSENAL 1-4 MAN CITY | TROOPZ FAN CAM | EDU SIGNED THESE FRAUDS, HE’S JUST AS BAD AS ARTETA!!",
            "description": "Subscribe To My Youtube: https://t.co/J7AXQuexvv\r\nADD ME ON:\r\nTwitter: https://twitter.com/Troopzafc\r\nInstagram: https://www.instagram.com/Troopzafc\r\nSnapchat: Troopz187"
          },
          "defaultAudioLanguage": "en-GB"
        },
        "contentDetails": {
          "duration": "PT8M57S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "293564",
          "likeCount": "10776",
          "dislikeCount": "255",
          "favoriteCount": "0",
          "commentCount": "2047"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Cn9InUuc8k90kXszYybqcfQaoD4",
        "id": "UocEGvQ10OE",
        "snippet": {
          "publishedAt": "2020-12-21T07:45:00Z",
          "channelId": "UCc4K7bAqpdBP8jh1j9XZAww",
          "title": "The Beatles:  Get Back - A Sneak Peek from Peter Jackson",
          "description": "PETER JACKSON REVEALS SNEAK PEEK OF HIS UPCOMING MUSIC DOCUMENTARY\n“THE BEATLES: GET BACK” ONLINE AND STREAMING ON DISNEY+ \n\nFeature-Length Film Opens in Theatres August 27, 2021\n\nAcclaimed filmmaker Peter Jackson has released an exclusive sneak peek of his upcoming documentary “The Beatles: Get Back” for fans everywhere to enjoy. The 5-minute special look is available to fans worldwide on TheBeatles.com and streaming on Disney+.\n \nJackson said, “We wanted to give the fans of The Beatles all over the world a holiday treat, so we put together this five-minute sneak peek at our upcoming theatrical film ‘The Beatles: Get Back.’ We hope it will bring a smile to everyone’s faces and some much-needed joy at this difficult time.”\n\nAcclaimed filmmaker Peter Jackson’s “The Beatles: Get Back” is a unique cinematic experience that takes audiences back in time to The Beatles’ intimate recording sessions during a pivotal moment in music history... \n\nRead more at https://www.thebeatles.com/news/beatles-get-back-sneak-peek-peter-jackson\n\n#TheBeatlesGetBack\n\nPhoto by Linda McCartney / © Paul McCartney",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/UocEGvQ10OE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/UocEGvQ10OE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/UocEGvQ10OE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/UocEGvQ10OE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/UocEGvQ10OE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "The Beatles",
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "The Beatles:  Get Back - A Sneak Peek from Peter Jackson",
            "description": "PETER JACKSON REVEALS SNEAK PEEK OF HIS UPCOMING MUSIC DOCUMENTARY\n“THE BEATLES: GET BACK” ONLINE AND STREAMING ON DISNEY+ \n\nFeature-Length Film Opens in Theatres August 27, 2021\n\nAcclaimed filmmaker Peter Jackson has released an exclusive sneak peek of his upcoming documentary “The Beatles: Get Back” for fans everywhere to enjoy. The 5-minute special look is available to fans worldwide on TheBeatles.com and streaming on Disney+.\n \nJackson said, “We wanted to give the fans of The Beatles all over the world a holiday treat, so we put together this five-minute sneak peek at our upcoming theatrical film ‘The Beatles: Get Back.’ We hope it will bring a smile to everyone’s faces and some much-needed joy at this difficult time.”\n\nAcclaimed filmmaker Peter Jackson’s “The Beatles: Get Back” is a unique cinematic experience that takes audiences back in time to The Beatles’ intimate recording sessions during a pivotal moment in music history... \n\nRead more at https://www.thebeatles.com/news/beatles-get-back-sneak-peek-peter-jackson\n\n#TheBeatlesGetBack\n\nPhoto by Linda McCartney / © Paul McCartney"
          },
          "defaultAudioLanguage": "en-GB"
        },
        "contentDetails": {
          "duration": "PT5M52S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2067732",
          "likeCount": "87854",
          "dislikeCount": "655",
          "favoriteCount": "0",
          "commentCount": "9467"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "wzgnrq_pIcOVLhkZ1UyhjewlUN0",
        "id": "-VyqsVbKFyo",
        "snippet": {
          "publishedAt": "2020-12-21T20:48:03Z",
          "channelId": "UCR_jb7PJVd3fYZLI_QX_nwA",
          "title": "ASKING NOAH BECK ABOUT DIXIE?! pt.2",
          "description": "Asking Noah Beck about his relationship with Dixie Damelio\n\nFOLLOW ME\nTikTok : https://www.tiktok.com/@blakegray\nInstagram : https://instagram.com/blakegray\nTwitter : https//twitter.com/blakegray\nSnapchat : Blake\n\nFOLLOW SWAY\nTikTok : https://www.tiktok.com/@theswayla\nInstagram : https://www.instagram.com/swayla\nYouTube : https://www.youtube.com/channel/UCVd9TykPzqcm1hwglZrx05g\n\nEdited and filmed by Matt: @mazzopardiii\nBusiness Inquiries: blake@talentxent.com",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/-VyqsVbKFyo/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/-VyqsVbKFyo/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/-VyqsVbKFyo/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/-VyqsVbKFyo/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/-VyqsVbKFyo/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Blake Gray",
          "tags": [
            "blake gray blake",
            "sway la",
            "sway house",
            "blake gray",
            "noah",
            "beck",
            "dixie",
            "nixie",
            "bryce",
            "hall",
            "damelio"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "ASKING NOAH BECK ABOUT DIXIE?! pt.2",
            "description": "Asking Noah Beck about his relationship with Dixie Damelio\n\nFOLLOW ME\nTikTok : https://www.tiktok.com/@blakegray\nInstagram : https://instagram.com/blakegray\nTwitter : https//twitter.com/blakegray\nSnapchat : Blake\n\nFOLLOW SWAY\nTikTok : https://www.tiktok.com/@theswayla\nInstagram : https://www.instagram.com/swayla\nYouTube : https://www.youtube.com/channel/UCVd9TykPzqcm1hwglZrx05g\n\nEdited and filmed by Matt: @mazzopardiii\nBusiness Inquiries: blake@talentxent.com"
          }
        },
        "contentDetails": {
          "duration": "PT7M4S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "476860",
          "likeCount": "32830",
          "dislikeCount": "635",
          "favoriteCount": "0",
          "commentCount": "1110"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "nWWnnhP21AdLFS7ac1RUpqz6w6Y",
        "id": "Ev2k8kucKTk",
        "snippet": {
          "publishedAt": "2020-12-20T06:39:03Z",
          "channelId": "UCurvRE5fGcdUgCYWgh-BDsg",
          "title": "HIGHLIGHTS | Canelo Alvarez vs. Callum Smith",
          "description": "December 19, 2020 -- Canelo Alvarez vs. Callum Smith from the Alamodome in San Antonio, Texas.\n\nSubscribe to our YouTube channel 👉  http://bit.ly/DAZNBoxingYouTube\n\nDownload the DAZN app now 👉  http://bit.ly/DAZN_YT\n\nFollow DAZN Boxing On Social Media 👇\nTwitter: https://www.twitter.com/DAZNBoxing\nInstagram: https://www.instagram.com/DAZNBoxing\nFacebook: https://www.facebook.com/DAZN",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/Ev2k8kucKTk/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/Ev2k8kucKTk/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/Ev2k8kucKTk/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/Ev2k8kucKTk/sddefault.jpg",
              "width": 640,
              "height": 480
            }
          },
          "channelTitle": "DAZN Boxing",
          "tags": [
            "dazn",
            "boxing",
            "highlights",
            "full fight",
            "ko",
            "knockout",
            "ryan garcia",
            "top 10",
            "canelo",
            "anthony joshua",
            "ggg",
            "haney",
            "callum smith",
            "canelo smith",
            "how to watch",
            "free",
            "stream",
            "champion",
            "belt",
            "three",
            "division"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "HIGHLIGHTS | Canelo Alvarez vs. Callum Smith",
            "description": "December 19, 2020 -- Canelo Alvarez vs. Callum Smith from the Alamodome in San Antonio, Texas.\n\nSubscribe to our YouTube channel 👉  http://bit.ly/DAZNBoxingYouTube\n\nDownload the DAZN app now 👉  http://bit.ly/DAZN_YT\n\nFollow DAZN Boxing On Social Media 👇\nTwitter: https://www.twitter.com/DAZNBoxing\nInstagram: https://www.instagram.com/DAZNBoxing\nFacebook: https://www.facebook.com/DAZN"
          },
          "defaultAudioLanguage": "en-US"
        },
        "contentDetails": {
          "duration": "PT12M45S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "regionRestriction": {
            "blocked": [
              "MX"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "4630473",
          "likeCount": "66652",
          "dislikeCount": "3704",
          "favoriteCount": "0",
          "commentCount": "12080"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "PRLjr0KWMSSrlyVwXZZJRSGL5_I",
        "id": "KAb6smLkOe8",
        "snippet": {
          "publishedAt": "2020-12-22T22:45:01Z",
          "channelId": "UCBJeMCIeLQos7wacox4hmLQ",
          "title": "Juventus 0-3 Fiorentina | HUGE Shock as Fiorentina Win Big at Juventus! | Serie A TIM",
          "description": "An early Dusan Vlahovic goal set Fiorentina on their way as they pulled off a massive shock to win at the Juventus Stadium | Serie A TIM\n\nThis is the official channel for the Serie A, providing all the latest highlights, interviews, news and features to keep you up to date with all things Italian football.\nSubscribe to the channel here! https://bit.ly/2OM2Eax\n \nFind out more about the Serie A at: http://www.legaseriea.it/en/ \n\nQuesto è il canale ufficiale della Serie A, dove potrai avere accesso ai momenti salienti, alle interviste, alle notizie e alle funzionalità del momento per rimanere aggiornato sulle ultime novità del campionato.\nIscriviti qui al canale! https://bit.ly/2OM2Eax\n\nPer maggiori informazioni sulla Serie A: http://www.legaseriea.it/it",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/KAb6smLkOe8/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/KAb6smLkOe8/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/KAb6smLkOe8/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/KAb6smLkOe8/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/KAb6smLkOe8/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Serie A",
          "tags": [
            "Ronaldo",
            "Serie A",
            "Dybala",
            "highlights",
            "Juventus",
            "AC Milan",
            "Inter Milan",
            "Napoli",
            "Roma",
            "CR7",
            "Cristiano Ronaldo",
            "goals",
            "full highlights",
            "watch",
            "stream",
            "partita",
            "migliori gol",
            "migliori in campo",
            "migliori al mondo",
            "gol del mese",
            "federcalcio",
            "calcio",
            "Italia",
            "lukaku",
            "Lazio",
            "zlatan",
            "ibrahimovic",
            "Ribery",
            "Fiorentina",
            "juventus fiorentina",
            "juventus fiorentina highlights",
            "juventus fiorentina 0 3",
            "vlahovic",
            "alex sandro",
            "cuadrado",
            "cacares",
            "matchid=A||2020-21||UNICO||UNI||14||JUVFIO"
          ],
          "categoryId": "17",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Juventus 0-3 Fiorentina | HUGE Shock as Fiorentina Win Big at Juventus! | Serie A TIM",
            "description": "An early Dusan Vlahovic goal set Fiorentina on their way as they pulled off a massive shock to win at the Juventus Stadium | Serie A TIM\n\nThis is the official channel for the Serie A, providing all the latest highlights, interviews, news and features to keep you up to date with all things Italian football.\nSubscribe to the channel here! https://bit.ly/2OM2Eax\n \nFind out more about the Serie A at: http://www.legaseriea.it/en/ \n\nQuesto è il canale ufficiale della Serie A, dove potrai avere accesso ai momenti salienti, alle interviste, alle notizie e alle funzionalità del momento per rimanere aggiornato sulle ultime novità del campionato.\nIscriviti qui al canale! https://bit.ly/2OM2Eax\n\nPer maggiori informazioni sulla Serie A: http://www.legaseriea.it/it"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT4M14S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "regionRestriction": {
            "blocked": [
              "IT"
            ]
          },
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2350909",
          "likeCount": "41320",
          "dislikeCount": "2907",
          "favoriteCount": "0",
          "commentCount": "4135"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "cPNqtDQOnQ80mQY4W5zNkAjM36Q",
        "id": "EmABso6rgqM",
        "snippet": {
          "publishedAt": "2020-12-21T19:25:40Z",
          "channelId": "UCqTYHSnBUXZamsVcOlQf-fg",
          "title": "Harry Potter - All Movies Reviewed and Ranked (part 1)",
          "description": "Thank you to @x_cixra_x and @SeigiVA for the cameos!!\n\nPatreon: https://www.patreon.com/cosmonautvarietyhour\r\n\r\nBUY A SHIRT: https://teespring.com/stores/cosmonaut-variety-merch-store\r\n\r\nTwitter: https://twitter.com/cosmovarietyhr",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/EmABso6rgqM/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/EmABso6rgqM/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/EmABso6rgqM/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/EmABso6rgqM/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/EmABso6rgqM/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "The Cosmonaut Variety Hour",
          "tags": [
            "cosmonaut variety hour",
            "cosmonaut",
            "commentary"
          ],
          "categoryId": "24",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Harry Potter - All Movies Reviewed and Ranked (part 1)",
            "description": "Thank you to @x_cixra_x and @SeigiVA for the cameos!!\n\nPatreon: https://www.patreon.com/cosmonautvarietyhour\r\n\r\nBUY A SHIRT: https://teespring.com/stores/cosmonaut-variety-merch-store\r\n\r\nTwitter: https://twitter.com/cosmovarietyhr"
          }
        },
        "contentDetails": {
          "duration": "PT38M23S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "507063",
          "likeCount": "48547",
          "dislikeCount": "1300",
          "favoriteCount": "0",
          "commentCount": "6494"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "FWY1EWBaLdj_LYrRwIW7lhC0S44",
        "id": "lFsumKiRVRs",
        "snippet": {
          "publishedAt": "2020-12-19T19:42:02Z",
          "channelId": "UCpB959t8iPrxQWj7G6n0ctQ",
          "title": "Mom Says Girls Can't Play Video Games ft SSSniperWolf",
          "description": "Mom Says Girls Can't Play Video Games ft SSSniperWolf! Leave a Like if you enjoyed! Watch the last vid https://youtu.be/ZORZh2ySHtw Subscribe to SSSniperWolf to join the Wolf Pack http://bit.ly/SubSSSniperWolf Check out Dhar Mann https://www.youtube.com/c/DharMannOfficial\n\nTikTok: http://tiktok.com/@sssniperwolf\nInstagram: http://instagram.com/sssniperwolf\nTwitter: http://www.twitter.com/sssniperwolf\nFacebook: https://www.facebook.com/sssniperwolf\nOfficial Merch: https://ogwolfpack.com/",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/lFsumKiRVRs/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/lFsumKiRVRs/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/lFsumKiRVRs/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/lFsumKiRVRs/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/lFsumKiRVRs/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "SSSniperWolf",
          "tags": [
            "sssniperwolf",
            "sniper wolf",
            "reacting",
            "reaction",
            "funny"
          ],
          "categoryId": "20",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Mom Says Girls Can't Play Video Games ft SSSniperWolf",
            "description": "Mom Says Girls Can't Play Video Games ft SSSniperWolf! Leave a Like if you enjoyed! Watch the last vid https://youtu.be/ZORZh2ySHtw Subscribe to SSSniperWolf to join the Wolf Pack http://bit.ly/SubSSSniperWolf Check out Dhar Mann https://www.youtube.com/c/DharMannOfficial\n\nTikTok: http://tiktok.com/@sssniperwolf\nInstagram: http://instagram.com/sssniperwolf\nTwitter: http://www.twitter.com/sssniperwolf\nFacebook: https://www.facebook.com/sssniperwolf\nOfficial Merch: https://ogwolfpack.com/"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT9M20S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "10488806",
          "likeCount": "441323",
          "dislikeCount": "10098",
          "favoriteCount": "0",
          "commentCount": "67173"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "Wm4GqyG_n9EVm8Wb27ufom3Y7ao",
        "id": "yHDXUT6EU8A",
        "snippet": {
          "publishedAt": "2020-12-21T23:45:10Z",
          "channelId": "UClG8odDC8TS6Zpqk9CGVQiQ",
          "title": "Marvel's Greatest Warriors and Royalty Come To Fortnite",
          "description": "The rightful king of Wakanda has come to the Island.\n\nWarriors can be formed for any reason whether it be a king's responsibility, a soldier's duty or a hired gun's price.  Black Panther, Captain Marvel and Taskmaster arrive in the Marvel Royalty & Warriors Pack! Grab the Pack in the Shop now.\n\nPlay Fortnite Battle Royale, the completely free 100-player PvP mode. One giant map, A Battle Bus, Last one standing wins. ESRB Rating: Teen with Violence.\r\n\r\nInstagram: https://www.instagram.com/fortnite/\r\nTwitter: https://twitter.com/FortniteGame\r\nFacebook: https://www.facebook.com/FortniteGame/\r\n\r\nLearn More: https://www.epicgames.com/fortnite/en-US/",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/yHDXUT6EU8A/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/yHDXUT6EU8A/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/yHDXUT6EU8A/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/yHDXUT6EU8A/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/yHDXUT6EU8A/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Fortnite",
          "tags": [
            "Fortnite",
            "Epic Games",
            "PC",
            "PS4",
            "Xbox One",
            "Battle Royale",
            "Unreal Tournament",
            "Unreal Engine",
            "Fortnite Battle Royale",
            "Fortnite Creative"
          ],
          "categoryId": "20",
          "liveBroadcastContent": "none",
          "defaultLanguage": "en",
          "localized": {
            "title": "Marvel's Greatest Warriors and Royalty Come To Fortnite",
            "description": "The rightful king of Wakanda has come to the Island.\n\nWarriors can be formed for any reason whether it be a king's responsibility, a soldier's duty or a hired gun's price.  Black Panther, Captain Marvel and Taskmaster arrive in the Marvel Royalty & Warriors Pack! Grab the Pack in the Shop now.\n\nPlay Fortnite Battle Royale, the completely free 100-player PvP mode. One giant map, A Battle Bus, Last one standing wins. ESRB Rating: Teen with Violence.\r\n\r\nInstagram: https://www.instagram.com/fortnite/\r\nTwitter: https://twitter.com/FortniteGame\r\nFacebook: https://www.facebook.com/FortniteGame/\r\n\r\nLearn More: https://www.epicgames.com/fortnite/en-US/"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT38S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "2501351",
          "likeCount": "206840",
          "dislikeCount": "2290",
          "favoriteCount": "0",
          "commentCount": "25006"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "1912NIQxpokyJ1eoh8qCVZS85Gg",
        "id": "i6B2gj8Y4eE",
        "snippet": {
          "publishedAt": "2020-12-22T00:17:16Z",
          "channelId": "UCjpzEgbbDUg4YC6vpSrzsyg",
          "title": "Here’s how to see the rare ‘Christmas Star’ on Monday",
          "description": "It all comes down to weather Monday evening. The rare Great Conjunction between Jupiter and Saturn is set to take center stage in our night.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/i6B2gj8Y4eE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/i6B2gj8Y4eE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/i6B2gj8Y4eE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/i6B2gj8Y4eE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/i6B2gj8Y4eE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "WKMG News 6 ClickOrlando",
          "categoryId": "25",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Here’s how to see the rare ‘Christmas Star’ on Monday",
            "description": "It all comes down to weather Monday evening. The rare Great Conjunction between Jupiter and Saturn is set to take center stage in our night."
          }
        },
        "contentDetails": {
          "duration": "PT3M27S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "227155",
          "likeCount": "1620",
          "dislikeCount": "108",
          "favoriteCount": "0",
          "commentCount": "211"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "0xttyXyZi3kPFltDQ3de8Vv6ScY",
        "id": "pEO2a7QzXqQ",
        "snippet": {
          "publishedAt": "2020-12-22T05:30:04Z",
          "channelId": "UCLtNvbkqea8wN_kGtfgx_Mw",
          "title": "KHYAAL RAKHYA KAR - Neha Kakkar ft. RohanPreet Singh | Anshul Garg | Babbu | Rajat Nagpal |",
          "description": "Anshul Garg presents KHYAAL RAKHYA KAR by the Queen Neha Kakkar ft. RohanPreet Singh. \n\nListen it on - 🎵\niTunes: https://music.apple.com/in/album/khyaal-rakhya-kar-single/1545300108\nGaana: https://gaana.com/song/khyaal-rakhya-kar-1\nSaavn: https://www.saavn.com/s/song/punjabi/Khyaal-Rakhya-Kar/Khyaal-Rakhya-Kar/BFofbiAGGgo\nSpotify: https://open.spotify.com/track/2RKGtM8v2JM72Gyo1wLmgg?si=gZeZ6u96SP2pwUnXNb4E1w\nApple Music: https://music.apple.com/in/album/khyaal-rakhya-kar-single/1545300108\nWynk: https://wynk.in/u/1Y0tgtj97\n\nSinger - Neha Kakkar \nMusic - Rajat Nagpal \nLyrics - Babbu\nSarangi Harpinder kang\nRecorded by Rahul Sharma @AMV assisted by Samir Dharap\n\nFeaturing - Neha Kakkar & Rohanpreet Singh\n\nProducer - Anshul Garg\n\nDirectors - Agam Mann & Azeem Mann\nConcept & Screenplay : Neha Kakkar \nVideo Supervisor - Raghav Sharma\nDOP - Shinda Singh\nChoreographer - John\nProject Manager - Piyush Chandok \nChildhood Neha - Guddu \nChildhood Rohanpreet - Aarush\nProduction - Rahul\nDI - Onkar Singh\nArt Director - Blacc\nADs - Jogi, Ashish Uppal, Jass Panesar, Ravi Goyal\nChild Artist casting - Elvin Art Academy Rajpura\nChildren - Ghazal, Rihanna, Kashvi, Saanvi, Eshanya, Kayanna, Nitya, Deepali, Inayat, Vrinda, Komal, Kavya,Vanya, Tanishtha, Drishti, Prince, Samar, Harshit, Himanshu, Viraj, Kairav, Aarav, Morfin, Garv, Gurshan, Namish, Kanishek\nCollege boy - Money Romana\nArtwork - Vicky Sandhu Design\nDistribution: Believe Digital\nPromotions : Underdog Digital\n\nLyrics :\n\nTu trump de warga hain\nMain obame wargi han\nTenu kyun lagda hai main\nKise drame wargi han\nTu cheez pyari hai ehnu sambhaal rakhya kar\nMera tu hi tu tan hain tu apna khyaal rakhya kar\n\nGallan wich laake tu taj mehal vikaa sakdan\nJinna tu jhootha hain politics ch jaa sakdan\nMethon na sach chupaaya kar\nJithe jana daske jaya kar\nMain fer tenu kuch nai kehndi\nKuch khaan nu laike aaya kar\nTe ghanta ghanta waiting wich na call rakhya kar\nMera tu hi tu tan hain tu apna khyaal rakhya kar\n\nTu brad pitt vadda na geriyan laaya kar\nJ kudi naal meeting hai Mainu naal lejaaya kar\nTenu kudiyan nal milaunde ne\nTere dost hi tenu pilaunde ne\nAh kaisa rang karaaya hai\nTenu ki ki oh sikhaunde ne\nChote hi changey lagde chote vaal rakhya kar\nMera tu hi tu tan hain Tu apna khyaal rakhya kar\n\n\n#KhyaalRakhyaKar #NehaKakkar #RohanPreet",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/pEO2a7QzXqQ/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/pEO2a7QzXqQ/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/pEO2a7QzXqQ/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/pEO2a7QzXqQ/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/pEO2a7QzXqQ/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Desi Music Factory",
          "tags": [
            "tony kakkar",
            "neha kakkar",
            "sonu kakkar",
            "music",
            "song",
            "desi music factory",
            "Neha Kakkar songs",
            "Nehu da vyah",
            "Karan aujla",
            "Sidhu moosewala songs",
            "Latest punjabi songs 2020",
            "Latest punjabi songs 2021",
            "Punjabi hits",
            "Chote hee change lagde",
            "Shona Shona",
            "Naach meri Laila",
            "Guru randhawa new song",
            "Jass manak new song"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "KHYAAL RAKHYA KAR - Neha Kakkar ft. RohanPreet Singh | Anshul Garg | Babbu | Rajat Nagpal |",
            "description": "Anshul Garg presents KHYAAL RAKHYA KAR by the Queen Neha Kakkar ft. RohanPreet Singh. \n\nListen it on - 🎵\niTunes: https://music.apple.com/in/album/khyaal-rakhya-kar-single/1545300108\nGaana: https://gaana.com/song/khyaal-rakhya-kar-1\nSaavn: https://www.saavn.com/s/song/punjabi/Khyaal-Rakhya-Kar/Khyaal-Rakhya-Kar/BFofbiAGGgo\nSpotify: https://open.spotify.com/track/2RKGtM8v2JM72Gyo1wLmgg?si=gZeZ6u96SP2pwUnXNb4E1w\nApple Music: https://music.apple.com/in/album/khyaal-rakhya-kar-single/1545300108\nWynk: https://wynk.in/u/1Y0tgtj97\n\nSinger - Neha Kakkar \nMusic - Rajat Nagpal \nLyrics - Babbu\nSarangi Harpinder kang\nRecorded by Rahul Sharma @AMV assisted by Samir Dharap\n\nFeaturing - Neha Kakkar & Rohanpreet Singh\n\nProducer - Anshul Garg\n\nDirectors - Agam Mann & Azeem Mann\nConcept & Screenplay : Neha Kakkar \nVideo Supervisor - Raghav Sharma\nDOP - Shinda Singh\nChoreographer - John\nProject Manager - Piyush Chandok \nChildhood Neha - Guddu \nChildhood Rohanpreet - Aarush\nProduction - Rahul\nDI - Onkar Singh\nArt Director - Blacc\nADs - Jogi, Ashish Uppal, Jass Panesar, Ravi Goyal\nChild Artist casting - Elvin Art Academy Rajpura\nChildren - Ghazal, Rihanna, Kashvi, Saanvi, Eshanya, Kayanna, Nitya, Deepali, Inayat, Vrinda, Komal, Kavya,Vanya, Tanishtha, Drishti, Prince, Samar, Harshit, Himanshu, Viraj, Kairav, Aarav, Morfin, Garv, Gurshan, Namish, Kanishek\nCollege boy - Money Romana\nArtwork - Vicky Sandhu Design\nDistribution: Believe Digital\nPromotions : Underdog Digital\n\nLyrics :\n\nTu trump de warga hain\nMain obame wargi han\nTenu kyun lagda hai main\nKise drame wargi han\nTu cheez pyari hai ehnu sambhaal rakhya kar\nMera tu hi tu tan hain tu apna khyaal rakhya kar\n\nGallan wich laake tu taj mehal vikaa sakdan\nJinna tu jhootha hain politics ch jaa sakdan\nMethon na sach chupaaya kar\nJithe jana daske jaya kar\nMain fer tenu kuch nai kehndi\nKuch khaan nu laike aaya kar\nTe ghanta ghanta waiting wich na call rakhya kar\nMera tu hi tu tan hain tu apna khyaal rakhya kar\n\nTu brad pitt vadda na geriyan laaya kar\nJ kudi naal meeting hai Mainu naal lejaaya kar\nTenu kudiyan nal milaunde ne\nTere dost hi tenu pilaunde ne\nAh kaisa rang karaaya hai\nTenu ki ki oh sikhaunde ne\nChote hi changey lagde chote vaal rakhya kar\nMera tu hi tu tan hain Tu apna khyaal rakhya kar\n\n\n#KhyaalRakhyaKar #NehaKakkar #RohanPreet"
          },
          "defaultAudioLanguage": "hi"
        },
        "contentDetails": {
          "duration": "PT3M34S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "18545740",
          "likeCount": "1421749",
          "dislikeCount": "43117",
          "favoriteCount": "0",
          "commentCount": "63229"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "FrDHfBDh0n8fXsdg3IFJkOpXFx4",
        "id": "1PIoiV2dp1c",
        "snippet": {
          "publishedAt": "2020-12-22T03:23:46Z",
          "channelId": "UCI78AdiI6f7VKhqW1i4B3Rw",
          "title": "ASMR MOZZARELLA CORN DOGS MUKBANG 먹방 | COOKING & EATING SOUNDS + THANK YOU FOR 10 MILLION SUBS",
          "description": "ASMR MOZZARELLA CORN DOGS MUKBANG 먹방 | COOKING & EATING SOUNDS + THANK YOU FOR 10 MILLION SUBS\n\nCheck out my Instagram: http://www.instagram.com/zachchoi\nCheck out my Facebook: http://www.facebook.com/zachchoiasmr\nCheck out my Twitter: http://www.twitter.com/zach_choi\n\nFilming Equipment:\nCamera: https://amzn.to/2MH1A8K\nMain Lens: https://amzn.to/3hd7M6r\nMacro Lens: https://amzn.to/2YmtbS2\nProbe Lens: https://amzn.to/2BJRRw6\nMain ASMR Microphone (x2): https://amzn.to/30vCGRB\nBackup ASMR Microphone (x2): https://amzn.to/30rB9Mw\nAudio Recorder: https://amzn.to/2ENGnZT\n\n***This is an ASMR video. To experience ASMR tingles, PLEASE WEAR HEADPHONES. If you do not enjoy EATING SOUNDS, DO NOT WATCH. ***\n\nWhat is ASMR?\nAutonomous Sensory Meridian Response is an experience characterized by a static-like or tingling sensation on the skin that typically begins on the scalp and moves down the back of the neck and upper spine.\n\n#10MillionSubs\n#CornDogs\n#ZachChoiASMR\n#Mukbang\n#Cookbang\n#Cooking\n#ASMR\n#ASMREating\n#asmrsounds\n#eatingsounds\n#NoTalking\n#letseat",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/1PIoiV2dp1c/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/1PIoiV2dp1c/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/1PIoiV2dp1c/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/1PIoiV2dp1c/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/1PIoiV2dp1c/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Zach Choi ASMR",
          "tags": [
            "asmr",
            " zach choi",
            "zachchoi",
            "zach choi asmr",
            "mukbang",
            "먹방",
            " 쇼",
            " 이팅",
            " 사운드",
            " korean asmr",
            "asmr eating",
            "asmr eating no talking",
            "asmr mukbang",
            "asmr mukbang no talking",
            "asmr mozzarella corn dog",
            "asmr mozzarella corn dog no talking",
            "asmr mozzarella sticks corn dogs",
            "asmr mozzarella cheese corn dogs",
            "asmr mozzarella corn dog recipe",
            "mozzarella corn dog recipe",
            "cooking mozzarella corn dogs",
            "asmr cheesy corn dogs",
            "diamond play button unboxing",
            "10 million subscribers",
            "yt:cc=on"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "ASMR MOZZARELLA CORN DOGS MUKBANG 먹방 | COOKING & EATING SOUNDS + THANK YOU FOR 10 MILLION SUBS",
            "description": "ASMR MOZZARELLA CORN DOGS MUKBANG 먹방 | COOKING & EATING SOUNDS + THANK YOU FOR 10 MILLION SUBS\n\nCheck out my Instagram: http://www.instagram.com/zachchoi\nCheck out my Facebook: http://www.facebook.com/zachchoiasmr\nCheck out my Twitter: http://www.twitter.com/zach_choi\n\nFilming Equipment:\nCamera: https://amzn.to/2MH1A8K\nMain Lens: https://amzn.to/3hd7M6r\nMacro Lens: https://amzn.to/2YmtbS2\nProbe Lens: https://amzn.to/2BJRRw6\nMain ASMR Microphone (x2): https://amzn.to/30vCGRB\nBackup ASMR Microphone (x2): https://amzn.to/30rB9Mw\nAudio Recorder: https://amzn.to/2ENGnZT\n\n***This is an ASMR video. To experience ASMR tingles, PLEASE WEAR HEADPHONES. If you do not enjoy EATING SOUNDS, DO NOT WATCH. ***\n\nWhat is ASMR?\nAutonomous Sensory Meridian Response is an experience characterized by a static-like or tingling sensation on the skin that typically begins on the scalp and moves down the back of the neck and upper spine.\n\n#10MillionSubs\n#CornDogs\n#ZachChoiASMR\n#Mukbang\n#Cookbang\n#Cooking\n#ASMR\n#ASMREating\n#asmrsounds\n#eatingsounds\n#NoTalking\n#letseat"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT19M9S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "666243",
          "likeCount": "59616",
          "dislikeCount": "1135",
          "favoriteCount": "0",
          "commentCount": "5344"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "zpApvA-h5lpDJJvPt7Wi0iTlqok",
        "id": "wuFeqg86YYE",
        "snippet": {
          "publishedAt": "2020-12-21T14:00:30Z",
          "channelId": "UCUOZvgB9Q8AgZjjLYcLWztQ",
          "title": "SEC Shorts - SEC fights to get two teams into the Playoff",
          "description": "After a crazy 2020 College football season, it all comes down to this.  Only four playoff spots are available and the SEC wants to get two teams in.  Water balloons and lots of other trouble stand in their way.",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/wuFeqg86YYE/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/wuFeqg86YYE/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/wuFeqg86YYE/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/wuFeqg86YYE/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/wuFeqg86YYE/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "SEC Shorts",
          "tags": [
            "sec shorts",
            "florida gators",
            "alabama crimson tide",
            "texas a&M aggies",
            "georgia bulldogs",
            "notre dame",
            "ohio state",
            "clemson"
          ],
          "categoryId": "23",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "SEC Shorts - SEC fights to get two teams into the Playoff",
            "description": "After a crazy 2020 College football season, it all comes down to this.  Only four playoff spots are available and the SEC wants to get two teams in.  Water balloons and lots of other trouble stand in their way."
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT4M3S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "true",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "458098",
          "likeCount": "12024",
          "dislikeCount": "169",
          "favoriteCount": "0",
          "commentCount": "2022"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "N4LgJ7NKL8Qr-VIr49rGyWKVNDg",
        "id": "QcS9ZndErHc",
        "snippet": {
          "publishedAt": "2020-12-22T00:00:10Z",
          "channelId": "UCnJoUTYXU142gxoyDzp-KRQ",
          "title": "Luísa Sonza, Pabllo Vittar, Anitta - MODO TURBO",
          "description": "SIGA LUÍSA SONZA: \nhttps://www.facebook.com/LuisaSonza \nhttps://twitter.com/luisasonza \nhttps://www.instagram.com/luisasonza\n\nUma produção UNIVERSAL MUSIC dirigida por Rafinha RSQ e Rennan Da Penha \n\nEquipe Universal \nDireção artística: Henrique Badke\nGerência artística: Miguel Afonso\nRepertório artístico audiovisual: Fernanda Mesa e Igor Alarcon\nCoordenação AeR: Junia Coutinho\nLabel Manager: Sergio Bernardo\n\nESTRELANDO: \nLuisa Sonza\nAnitta \nPabllo Vittar\n \nDIREÇÃO \nAlaska\n \nEQUIPE LUÍSA SONZA \nEmpresariamento: Fátima Pissarra\nDiretor artístico: André Corga\nProdutor executivo: Lucas Pinho\nProdutora: Karina Fermi\nDiretor criativo e coreógrafo: Flavio Verne\nBeauty:  Pedro Moreira \nAssistente Beauty: Dan Cannavan \nFigurinista: Victor Miranda \nProdução de moda: Jorge Moura \nCamareira: Nádia Martins\nAssistente Pessoal: Tay Vargas\n \nEQUIPE PABLLO VITTAR \nBeleza:  Thereza \nStyling:  João França \nAssistência e produção de moda: Coletivo Gaia \nFotos: Pabllo Ernnacost \nProdução: Mataderos\n \nEQUIPE ANITTA \nBeauty:  Henrique Cardoso Martins\nAssistente Beauty : Helio Santana da Franca\nStylist: Maria Clara Ribeiro Lima\nAss. de Figurino: Otavio Donardelli Calixto\n \nProdução Executiva: Francesco Civita e Henrique Danielletto\nDiretor de Fotografia: Mauricio Padilha\nDiretor de Arte: Pedro Catellani (Bolo)\nDiretor de Produção: Reinaldo Faria Aniceto Junior \nCoordenador de Produção: Andre Bauer\nFigurinista Concept: Ana Wainer\n \nMaquiadora e Caracterização: Patrícia Martinelli\nCarcacterização : Vick Garaventa\nMontador: Marcelo Vongelar\nPós Produção: Post it\nEfeitos Sonoros : Satelite Áudio\nDesign Gráfico: Isabela Vdd e Gabriela Osilio\nIlustradora: Fernanda Padro\nCoreógrafo: Flavio Verne\nDançarino Robô: Eddy Soares\n1º Ass Direção: Tays Perez\n2ª Ass Direção: Giulia Levy Costa\nAss. Criativo: Pedro Oranges de Figueiredo\n \nAss. Coordenação de Produção: Carolina Loureiro\nAss. Coordenação de Produção: Carol Latorre\nAss. Coordenação de Produção: Samantha Assis\nControladoria: Fabiana Baptista\nControladoria: Lucas Pereira\nProdutora: Patricia Rumi Nagaoka\nAss Produção: Ronder William Alencar Batista \nAss Produção: Gabriela Sena\nAssistente de Set: Carlos Rogerio da Cunha \nAssistente de Set: Gabriel Amadio\nAssistente de Set: Hiago Skarff Andrade lopes\nAssistente de Set: Daniel Bezerra Campos\nAssistente de Set: Jailson de Siqueira França\nAssistente de Set:  Anderson da Silva Peres Camacho\nAssistente de Set:  Robson Martins Barbosa\nAssistente de Set:  Rodrigo Dias \nProdutor de Locação: Kleber Martins Pereira\nAss Produção Executiva: Matheus Monteiro\nTécnico de Som Direto: Sidney Santos Sapucaía (Xuxa) \n \nEQUIPE FOTOGRAFIA \nDiretor de Fotografia (2ª unidade): Fabio Politi\n1º Assistente de Câmera: Marcio Gomes de Mello\n2º Assistente de Câmera: Jonas Tadei Sossai\nLogger: Diego Valenzuela Santelices da Fonseca\nLogger: Marcelo Krowczuk de Faria\nVideo Assist:  Daniela de Oliveira\nMov: Renato Monteiro Passarelli\nMov: Leonardo Silva Pereira Pinto\nMov: Luiz Roberto Pereira Albertin\nMov: Luiz Ricardo de Oliveira Freitas\nMontador: Paulo Rogério dos Santos\nOperador da cabeça: Sandro Augusto de Melo Galvão\nFotografa Still: isabela valentini di dario\n1º Assistente de Câmera 2º unidade: André de Oliveira Alves\nDrone: Thiago Bianchi\n \nELÉTRICA \nEletricista Marcelo Pinheiro de Camargo\n1º Ass de Elétrica  Flavio Francisco do Nascimento\n2º Ass de Elétrica Gabriel Vinicius Camargo de Souza\n2º Ass de Elétrica Luiz Felipe Correa da Silva\n2º Ass de Elétrica paulo antonio lino da silva\n2º Ass de Elétrica Paulo Henrique Magalhães\n2º Ass de Elétrica Cleiton Jonas Fernandes\n2º Ass de Elétrica Vinicius Torres dos Santos\n2º Ass de Elétrica Adriano Henrique de Miranda\nGeradorista Sérgio Ricardo Miranda\n \nMAQUINÁRIA \nMaquinista Weber Jose da Silva Cunha (Cabelo)\n1º Ass de Maquinária Alex Sandro Costa Viana\n1º Ass de Maquinária Rui Mauriti Nunes Araújo\n2º Ass de Maquinária Luís Augusto da Silva (Cidinho)\n2º Ass de Maquinária kaique Augusto pereira de  souza\n2º Ass de Maquinária Eduardo luis santiago souza\n2º Ass de Maquinária Thiago Ferreira de Carvalho fidalgo\n2º Ass de Maquinária Celso Vieira Neto\n2º Ass de Maquinária Luis Marcell Dhyonis de Souza Bento\n2º Ass de Maquinária Paulo Cardoso Da Silva\n2º Ass de Maquinária David Junior da Silva\n \nEQUIPE EFEITO  \nTécnico de efeitos Vagner Aparecido (Martão)\nTécnico de efeitos Valter Vieira Carrasco\nAss de efeito Tadeu Guimarães Farabelo\nAss de efeito Carlos Alberto de Lima\nAss de efeito Valter Carrasco Junior\nAss de efeito Vinicios Santos de Melo\nTécnico de efeitos Bruno Roberto Steger Tozzi\nAss de efeito Wesley Belarmino\nAss de efeito Mayci dos Reis Tozzi\n \nEQUIPE FIGURINO  \nAssistente de Figurino Tulio Barbosa Melles\nAssistente de Figurino Juliana Santana Santos\nAssistente de Figurino Jessica Kelly Gonçalves de Carvalho \nCostureira Edna Maria Mesquita Pereira\n \nEQUIPE ARTE e  OBJETOS \nAssistente Diretor de Arte Isabel Isak Cezar de Andrade \nAssistente Diretor de Arte Thais Russo\nProdutor de Arte Marcio Gomes",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/QcS9ZndErHc/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/QcS9ZndErHc/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/QcS9ZndErHc/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/QcS9ZndErHc/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/QcS9ZndErHc/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Luísa Sonza",
          "tags": [
            "clipe",
            "cover",
            "covergirl",
            "luisa sonza",
            "sonza",
            "souza",
            "sousa",
            "oficial",
            "single",
            "música",
            "musica",
            "Luisa Sonza",
            "luisa",
            "luiza",
            "lu",
            "lu sonza",
            "modo turbo",
            "anitta",
            "pabllo vittar",
            "braba",
            "me gusta",
            "bandida",
            "amor de que",
            "sua cara",
            "rajadao",
            "anitta netflix",
            "anitta honorio",
            "disk me",
            "ko",
            "flores",
            "combatchy",
            "toma",
            "século 21",
            "desce pro play",
            "papapa",
            "vai malandra"
          ],
          "categoryId": "10",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "Luísa Sonza, Pabllo Vittar, Anitta - MODO TURBO",
            "description": "SIGA LUÍSA SONZA: \nhttps://www.facebook.com/LuisaSonza \nhttps://twitter.com/luisasonza \nhttps://www.instagram.com/luisasonza\n\nUma produção UNIVERSAL MUSIC dirigida por Rafinha RSQ e Rennan Da Penha \n\nEquipe Universal \nDireção artística: Henrique Badke\nGerência artística: Miguel Afonso\nRepertório artístico audiovisual: Fernanda Mesa e Igor Alarcon\nCoordenação AeR: Junia Coutinho\nLabel Manager: Sergio Bernardo\n\nESTRELANDO: \nLuisa Sonza\nAnitta \nPabllo Vittar\n \nDIREÇÃO \nAlaska\n \nEQUIPE LUÍSA SONZA \nEmpresariamento: Fátima Pissarra\nDiretor artístico: André Corga\nProdutor executivo: Lucas Pinho\nProdutora: Karina Fermi\nDiretor criativo e coreógrafo: Flavio Verne\nBeauty:  Pedro Moreira \nAssistente Beauty: Dan Cannavan \nFigurinista: Victor Miranda \nProdução de moda: Jorge Moura \nCamareira: Nádia Martins\nAssistente Pessoal: Tay Vargas\n \nEQUIPE PABLLO VITTAR \nBeleza:  Thereza \nStyling:  João França \nAssistência e produção de moda: Coletivo Gaia \nFotos: Pabllo Ernnacost \nProdução: Mataderos\n \nEQUIPE ANITTA \nBeauty:  Henrique Cardoso Martins\nAssistente Beauty : Helio Santana da Franca\nStylist: Maria Clara Ribeiro Lima\nAss. de Figurino: Otavio Donardelli Calixto\n \nProdução Executiva: Francesco Civita e Henrique Danielletto\nDiretor de Fotografia: Mauricio Padilha\nDiretor de Arte: Pedro Catellani (Bolo)\nDiretor de Produção: Reinaldo Faria Aniceto Junior \nCoordenador de Produção: Andre Bauer\nFigurinista Concept: Ana Wainer\n \nMaquiadora e Caracterização: Patrícia Martinelli\nCarcacterização : Vick Garaventa\nMontador: Marcelo Vongelar\nPós Produção: Post it\nEfeitos Sonoros : Satelite Áudio\nDesign Gráfico: Isabela Vdd e Gabriela Osilio\nIlustradora: Fernanda Padro\nCoreógrafo: Flavio Verne\nDançarino Robô: Eddy Soares\n1º Ass Direção: Tays Perez\n2ª Ass Direção: Giulia Levy Costa\nAss. Criativo: Pedro Oranges de Figueiredo\n \nAss. Coordenação de Produção: Carolina Loureiro\nAss. Coordenação de Produção: Carol Latorre\nAss. Coordenação de Produção: Samantha Assis\nControladoria: Fabiana Baptista\nControladoria: Lucas Pereira\nProdutora: Patricia Rumi Nagaoka\nAss Produção: Ronder William Alencar Batista \nAss Produção: Gabriela Sena\nAssistente de Set: Carlos Rogerio da Cunha \nAssistente de Set: Gabriel Amadio\nAssistente de Set: Hiago Skarff Andrade lopes\nAssistente de Set: Daniel Bezerra Campos\nAssistente de Set: Jailson de Siqueira França\nAssistente de Set:  Anderson da Silva Peres Camacho\nAssistente de Set:  Robson Martins Barbosa\nAssistente de Set:  Rodrigo Dias \nProdutor de Locação: Kleber Martins Pereira\nAss Produção Executiva: Matheus Monteiro\nTécnico de Som Direto: Sidney Santos Sapucaía (Xuxa) \n \nEQUIPE FOTOGRAFIA \nDiretor de Fotografia (2ª unidade): Fabio Politi\n1º Assistente de Câmera: Marcio Gomes de Mello\n2º Assistente de Câmera: Jonas Tadei Sossai\nLogger: Diego Valenzuela Santelices da Fonseca\nLogger: Marcelo Krowczuk de Faria\nVideo Assist:  Daniela de Oliveira\nMov: Renato Monteiro Passarelli\nMov: Leonardo Silva Pereira Pinto\nMov: Luiz Roberto Pereira Albertin\nMov: Luiz Ricardo de Oliveira Freitas\nMontador: Paulo Rogério dos Santos\nOperador da cabeça: Sandro Augusto de Melo Galvão\nFotografa Still: isabela valentini di dario\n1º Assistente de Câmera 2º unidade: André de Oliveira Alves\nDrone: Thiago Bianchi\n \nELÉTRICA \nEletricista Marcelo Pinheiro de Camargo\n1º Ass de Elétrica  Flavio Francisco do Nascimento\n2º Ass de Elétrica Gabriel Vinicius Camargo de Souza\n2º Ass de Elétrica Luiz Felipe Correa da Silva\n2º Ass de Elétrica paulo antonio lino da silva\n2º Ass de Elétrica Paulo Henrique Magalhães\n2º Ass de Elétrica Cleiton Jonas Fernandes\n2º Ass de Elétrica Vinicius Torres dos Santos\n2º Ass de Elétrica Adriano Henrique de Miranda\nGeradorista Sérgio Ricardo Miranda\n \nMAQUINÁRIA \nMaquinista Weber Jose da Silva Cunha (Cabelo)\n1º Ass de Maquinária Alex Sandro Costa Viana\n1º Ass de Maquinária Rui Mauriti Nunes Araújo\n2º Ass de Maquinária Luís Augusto da Silva (Cidinho)\n2º Ass de Maquinária kaique Augusto pereira de  souza\n2º Ass de Maquinária Eduardo luis santiago souza\n2º Ass de Maquinária Thiago Ferreira de Carvalho fidalgo\n2º Ass de Maquinária Celso Vieira Neto\n2º Ass de Maquinária Luis Marcell Dhyonis de Souza Bento\n2º Ass de Maquinária Paulo Cardoso Da Silva\n2º Ass de Maquinária David Junior da Silva\n \nEQUIPE EFEITO  \nTécnico de efeitos Vagner Aparecido (Martão)\nTécnico de efeitos Valter Vieira Carrasco\nAss de efeito Tadeu Guimarães Farabelo\nAss de efeito Carlos Alberto de Lima\nAss de efeito Valter Carrasco Junior\nAss de efeito Vinicios Santos de Melo\nTécnico de efeitos Bruno Roberto Steger Tozzi\nAss de efeito Wesley Belarmino\nAss de efeito Mayci dos Reis Tozzi\n \nEQUIPE FIGURINO  \nAssistente de Figurino Tulio Barbosa Melles\nAssistente de Figurino Juliana Santana Santos\nAssistente de Figurino Jessica Kelly Gonçalves de Carvalho \nCostureira Edna Maria Mesquita Pereira\n \nEQUIPE ARTE e  OBJETOS \nAssistente Diretor de Arte Isabel Isak Cezar de Andrade \nAssistente Diretor de Arte Thais Russo\nProdutor de Arte Marcio Gomes"
          },
          "defaultAudioLanguage": "pt"
        },
        "contentDetails": {
          "duration": "PT2M55S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": false,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "10537622",
          "likeCount": "1111191",
          "dislikeCount": "41585",
          "favoriteCount": "0",
          "commentCount": "137462"
        }
      },
      {
        "kind": "youtube#video",
        "etag": "gl75OUERdNa35tAajlY61U4oLY0",
        "id": "w5qJNM4yyF8",
        "snippet": {
          "publishedAt": "2020-12-21T23:32:34Z",
          "channelId": "UCj0lRqUVkLgTpHZxzyionQw",
          "title": "We TASTED Mr. Beast Burger Restaurant... (Here's what happened...) *FULL MENU*",
          "description": "STREAM GIRL NEXT DOOR ► https://ffm.to/girlnextdoor\nText me: 323-405-9940\nFREE Spotify Playlist ► https://open.spotify.com/playlist/2FE6ofE15fQyN995nCOq9d\nFREE Apple Playlist ► https://music.apple.com/us/playlist/chill-music-got-me-in-my-feelings/pl.u-vxy6kpxT46JK11\n\nJoin the #TAYLORFAM ►http://bit.ly/SubscribeToBrennen \n \nLast Vlog ► https://www.youtube.com/watch?v=uOPUld2ngZ8&t=102s\n\nMERCH ► http://www.BrennenTaylor.com/\n\nTikTok ► http://www.tiktok.com/@BrennenTaylor\n\nTwitter ► http://www.twitter.com/BrennenTaylor\n\nInstagram ► http://www.instagram.com/Brennen\n\nSnapchat ►  http://www.snapchat.com/add/BrennenTaylor\n\nFOLLOW JAKE:\n► http://www.instagram.com/JakeTaylor\n► http://www.twitter.com/jakextaylor\n► http://www.tiktok.com/@jaketaylorx\n\n\nHi I'm Brennen.  I've been eating food for 24 years. I'm basically a professional. Here is my Food Review:\n\nPO BOX: 3844 Chatsworth CA 91313-3844\nBusiness email ONLY: MGMT@BrennenTaylor.com\n\nBrennen Taylor best/worst reviewed videos of 1 star yelp restaurants and businesses series and his newly beloved viral tikok life hack tik tok lifehack series.Family friendly pg clean",
          "thumbnails": {
            "default": {
              "url": "https://i.ytimg.com/vi/w5qJNM4yyF8/default.jpg",
              "width": 120,
              "height": 90
            },
            "medium": {
              "url": "https://i.ytimg.com/vi/w5qJNM4yyF8/mqdefault.jpg",
              "width": 320,
              "height": 180
            },
            "high": {
              "url": "https://i.ytimg.com/vi/w5qJNM4yyF8/hqdefault.jpg",
              "width": 480,
              "height": 360
            },
            "standard": {
              "url": "https://i.ytimg.com/vi/w5qJNM4yyF8/sddefault.jpg",
              "width": 640,
              "height": 480
            },
            "maxres": {
              "url": "https://i.ytimg.com/vi/w5qJNM4yyF8/maxresdefault.jpg",
              "width": 1280,
              "height": 720
            }
          },
          "channelTitle": "Brennen Taylor",
          "tags": [
            "brennentaylor",
            "brennen taylor",
            "brennen",
            "taylor",
            "taylorfam",
            "mr beast",
            "mr beast burger review",
            "beast burger review",
            "worst reviewed",
            "1 star",
            "mr beast burgers",
            "mr beast burger location",
            "mrbeast restaurant",
            "mr",
            "beast",
            "mrbeast burger",
            "mrbeast",
            "mrbeast burger review",
            "mr beast burger restaurant",
            "mr beast burger shop",
            "mr beast burger mukbang",
            "mr beast burger raw",
            "mr beast burger app"
          ],
          "categoryId": "22",
          "liveBroadcastContent": "none",
          "localized": {
            "title": "We TASTED Mr. Beast Burger Restaurant... (Here's what happened...) *FULL MENU*",
            "description": "STREAM GIRL NEXT DOOR ► https://ffm.to/girlnextdoor\nText me: 323-405-9940\nFREE Spotify Playlist ► https://open.spotify.com/playlist/2FE6ofE15fQyN995nCOq9d\nFREE Apple Playlist ► https://music.apple.com/us/playlist/chill-music-got-me-in-my-feelings/pl.u-vxy6kpxT46JK11\n\nJoin the #TAYLORFAM ►http://bit.ly/SubscribeToBrennen \n \nLast Vlog ► https://www.youtube.com/watch?v=uOPUld2ngZ8&t=102s\n\nMERCH ► http://www.BrennenTaylor.com/\n\nTikTok ► http://www.tiktok.com/@BrennenTaylor\n\nTwitter ► http://www.twitter.com/BrennenTaylor\n\nInstagram ► http://www.instagram.com/Brennen\n\nSnapchat ►  http://www.snapchat.com/add/BrennenTaylor\n\nFOLLOW JAKE:\n► http://www.instagram.com/JakeTaylor\n► http://www.twitter.com/jakextaylor\n► http://www.tiktok.com/@jaketaylorx\n\n\nHi I'm Brennen.  I've been eating food for 24 years. I'm basically a professional. Here is my Food Review:\n\nPO BOX: 3844 Chatsworth CA 91313-3844\nBusiness email ONLY: MGMT@BrennenTaylor.com\n\nBrennen Taylor best/worst reviewed videos of 1 star yelp restaurants and businesses series and his newly beloved viral tikok life hack tik tok lifehack series.Family friendly pg clean"
          },
          "defaultAudioLanguage": "en"
        },
        "contentDetails": {
          "duration": "PT14M30S",
          "dimension": "2d",
          "definition": "hd",
          "caption": "false",
          "licensedContent": true,
          "contentRating": {},
          "projection": "rectangular"
        },
        "statistics": {
          "viewCount": "354696",
          "likeCount": "20268",
          "dislikeCount": "1622",
          "favoriteCount": "0",
          "commentCount": "2129"
        }
      }
    ],
    "nextPageToken": "CDIQAA",
    "pageInfo": {
      "totalResults": 200,
      "resultsPerPage": 50
    }
  }
  